/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: string;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { [key: string]: any };
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: any;
};

/** All input for the `acceptInvite` mutation. */
export type AcceptInviteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviteLinkId: Scalars['UUID'];
};

/** The output of our `acceptInvite` mutation. */
export type AcceptInvitePayload = {
  __typename?: 'AcceptInvitePayload';
  /** Reads a single `Account` that is related to this `InviteLink`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  inviteLink: Maybe<InviteLink>;
  /** An edge for our `InviteLink`. May be used by Relay 1. */
  inviteLinkEdge: Maybe<InviteLinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Role` that is related to this `InviteLink`. */
  role: Maybe<Role>;
  /** Reads a single `User` that is related to this `InviteLink`. */
  user: Maybe<User>;
};

/** The output of our `acceptInvite` mutation. */
export type AcceptInvitePayloadInviteLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<InviteLinksOrderBy>>;
};

/** All input for the `acceptTerms` mutation. */
export type AcceptTermsInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `acceptTerms` mutation. */
export type AcceptTermsPayload = {
  __typename?: 'AcceptTermsPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type Account = {
  __typename?: 'Account';
  /** Reads and enables pagination through a set of `AccountFeature`. */
  accountFeatures: AccountFeaturesConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYears: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountMembership`. */
  accountMemberships: AccountMembershipsConnection;
  /** Reads a single `AccountsOwner` that is related to this `Account`. */
  accountsOwnerByAccountsId: Maybe<AccountsOwner>;
  /** Reads a single `AccountsSystem` that is related to this `Account`. */
  accountsSystemByAccountsId: Maybe<AccountsSystem>;
  /** The unique identifier for this district inside the AFR system. This is generated externally, and must be populated. */
  afrId: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `AiDocumentEmbedding`. */
  aiDocumentEmbeddings: AiDocumentEmbeddingsConnection;
  /** Reads and enables pagination through a set of `AiDocumentSource`. */
  aiDocumentSources: AiDocumentSourcesConnection;
  /** Reads and enables pagination through a set of `AiDocument`. */
  aiDocuments: AiDocumentsConnection;
  /** Reads a single `AiUsageConfig` that is related to this `Account`. */
  aiUsageConfig: Maybe<AiUsageConfig>;
  /** Reads and enables pagination through a set of `AiUsageLog`. */
  aiUsageLogs: AiUsageLogsConnection;
  /** Reads and enables pagination through a set of `CodeCheckCustomization`. */
  codeCheckCustomizations: CodeCheckCustomizationsConnection;
  /** Reads and enables pagination through a set of `DistrictCoaSegment`. */
  districtCoaSegments: DistrictCoaSegmentsConnection;
  /** Reads and enables pagination through a set of `DistrictCodeOption`. */
  districtCodeOptions: DistrictCodeOptionsConnection;
  /** Reads and enables pagination through a set of `DistrictContact`. */
  districtContacts: DistrictContactsConnection;
  /** Reads and enables pagination through a set of `File`. */
  files: FilesConnection;
  /** Reads and enables pagination through a set of `FutureJob`. */
  futureJobs: FutureJobsConnection;
  /** Reads and enables pagination through a set of `GeneralLedger`. */
  generalLedgers: GeneralLedgersConnection;
  /** Reads and enables pagination through a set of `HelpTicket`. */
  helpTickets: HelpTicketsConnection;
  /** Primary key of the Account. */
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InviteLink`. */
  inviteLinks: InviteLinksConnection;
  /** The name of the school district/entity. */
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
  /** The unique identifier in the payment processor that relates to this account. */
  paymentProcessorAccountId: Maybe<Scalars['String']>;
  /** The customized Power BI report URL for this account. If not provided, the default basic report will be used. */
  powerBiReportUrl: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Report`. */
  reports: ReportsConnection;
  /** Reads and enables pagination through a set of `School`. */
  schools: SchoolsConnection;
  /** Reads and enables pagination through a set of `SpedRecord`. */
  spedRecords: SpedRecordsConnection;
  /** Reads a single `State` that is related to this `Account`. */
  state: Maybe<State>;
  stateId: Scalars['UUID'];
  /** The current status of this account. The status describes whether or not the account is actively owned by a user, late on a payment, or owned exclusively by the system. */
  status: Maybe<AccountStatus>;
};

export type AccountAccountFeaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFeatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFeaturesOrderBy>>;
};

export type AccountAccountFiscalYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type AccountAccountMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountMembershipCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountMembershipsOrderBy>>;
};

export type AccountAiDocumentEmbeddingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentEmbeddingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentEmbeddingsOrderBy>>;
};

export type AccountAiDocumentSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentSourceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentSourcesOrderBy>>;
};

export type AccountAiDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentsOrderBy>>;
};

export type AccountAiUsageLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiUsageLogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiUsageLogsOrderBy>>;
};

export type AccountCodeCheckCustomizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CodeCheckCustomizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CodeCheckCustomizationsOrderBy>>;
};

export type AccountDistrictCoaSegmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictCoaSegmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictCoaSegmentsOrderBy>>;
};

export type AccountDistrictCodeOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictCodeOptionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictCodeOptionsOrderBy>>;
};

export type AccountDistrictContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictContactsOrderBy>>;
};

export type AccountFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FileCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

export type AccountFutureJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureJobCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureJobsOrderBy>>;
};

export type AccountGeneralLedgersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GeneralLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeneralLedgersOrderBy>>;
};

export type AccountHelpTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HelpTicketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HelpTicketsOrderBy>>;
};

export type AccountInviteLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InviteLinkCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InviteLinksOrderBy>>;
};

export type AccountNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

export type AccountReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

export type AccountSchoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SchoolCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SchoolsOrderBy>>;
};

export type AccountSpedRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SpedRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpedRecordsOrderBy>>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stateId` field. */
  stateId?: InputMaybe<Scalars['UUID']>;
};

export type AccountFeature = {
  __typename?: 'AccountFeature';
  /** Reads a single `Account` that is related to this `AccountFeature`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** The date this feature expires. */
  expiresAt: Maybe<Scalars['Datetime']>;
  /** Reads a single `Feature` that is related to this `AccountFeature`. */
  feature: Maybe<Feature>;
  featureId: Maybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `AccountFeature` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountFeatureCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `featureId` field. */
  featureId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AccountFeature` values. */
export type AccountFeaturesConnection = {
  __typename?: 'AccountFeaturesConnection';
  /** A list of edges which contains the `AccountFeature` and cursor to aid in pagination. */
  edges: Array<AccountFeaturesEdge>;
  /** A list of `AccountFeature` objects. */
  nodes: Array<AccountFeature>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountFeature` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountFeature` edge in the connection. */
export type AccountFeaturesEdge = {
  __typename?: 'AccountFeaturesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AccountFeature` at the end of the edge. */
  node: AccountFeature;
};

/** Methods to use when ordering `AccountFeature`. */
export enum AccountFeaturesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FeatureIdAsc = 'FEATURE_ID_ASC',
  FeatureIdDesc = 'FEATURE_ID_DESC',
  Natural = 'NATURAL',
}

export type AccountFiscalYear = {
  __typename?: 'AccountFiscalYear';
  /** Reads a single `Account` that is related to this `AccountFiscalYear`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  adoptedBudgetFile: Maybe<File>;
  adoptedBudgetFileId: Maybe<Scalars['UUID']>;
  /** The publicly accessible URL that the district will use to provide their public financial information. */
  afrWebsite: Maybe<Scalars['String']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  bsa21File: Maybe<File>;
  bsa21FileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  bsa55File: Maybe<File>;
  bsa55FileId: Maybe<Scalars['UUID']>;
  /** The payment period (e.g., "November", "SRC") for the BSA55 file. */
  bsa55PaymentPeriod: Maybe<Scalars['String']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  budg75File: Maybe<File>;
  budg75FileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  budgetFile: Maybe<File>;
  budgetFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  budgetRevisionExtractedDataFile: Maybe<File>;
  budgetRevisionExtractedDataFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  chartOfAccountsFile: Maybe<File>;
  chartOfAccountsFileId: Maybe<Scalars['UUID']>;
  /** The county of the entity. */
  county: Scalars['String'];
  /** The ctds code of the entity. */
  ctdsCode: Scalars['String'];
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  desegBudgetFile: Maybe<File>;
  desegBudgetFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  externalBudgetDataFile: Maybe<File>;
  externalBudgetDataFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  externalBudgetRevisionDataFile: Maybe<File>;
  externalBudgetRevisionDataFileId: Maybe<Scalars['UUID']>;
  /** The rule overrides used when normalizing general ledger files for this account. */
  fileIngestOverrides: Maybe<Scalars['JSON']>;
  /** The rule overrides used when processing general ledger files for this account. */
  fileProcessingOverrides: Maybe<Scalars['JSON']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  finalAfrFile: Maybe<File>;
  finalAfrFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `FiscalYear` that is related to this `AccountFiscalYear`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Whether or not this account needs to apply rules for desegregation. */
  hasDesegregation: Maybe<Scalars['Boolean']>;
  /** Whether or not this account needs to apply rules for food services. */
  hasFoodService: Maybe<Scalars['Boolean']>;
  /** The Instructional Improvement Fund (IIF) payment value for this school district. */
  iifValue: Maybe<Scalars['String']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  prevYearAfrFile: Maybe<File>;
  prevYearAfrFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  prevYearDesegAfrFile: Maybe<File>;
  prevYearDesegAfrFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  prevYearFoodServiceAfrFile: Maybe<File>;
  prevYearFoodServiceAfrFileId: Maybe<Scalars['UUID']>;
  /** The primary unit code of the entity. */
  primaryUnitCode: Scalars['String'];
  /** Whether or not this account has school-level allocation enabled. */
  schoolLevelAllocation: Maybe<Scalars['Boolean']>;
  /** Whether or not this account should be treated as a single school district. */
  singleSchoolDistrict: Maybe<Scalars['Boolean']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  sped20File: Maybe<File>;
  sped20FileId: Maybe<Scalars['UUID']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  sped30File: Maybe<File>;
  sped30FileId: Maybe<Scalars['UUID']>;
  /** The number of teachers in the district with 3 or fewer years of experience. */
  threeOrLessYearsTeacherCount: Scalars['Int'];
  /** The total number of teachers in the district. */
  totalTeacherCount: Scalars['Int'];
};

/**
 * A condition to be used against `AccountFiscalYear` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountFiscalYearCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `adoptedBudgetFileId` field. */
  adoptedBudgetFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `bsa21FileId` field. */
  bsa21FileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `bsa55FileId` field. */
  bsa55FileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `budg75FileId` field. */
  budg75FileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `budgetFileId` field. */
  budgetFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `budgetRevisionExtractedDataFileId` field. */
  budgetRevisionExtractedDataFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `chartOfAccountsFileId` field. */
  chartOfAccountsFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `desegBudgetFileId` field. */
  desegBudgetFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `externalBudgetDataFileId` field. */
  externalBudgetDataFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `externalBudgetRevisionDataFileId` field. */
  externalBudgetRevisionDataFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `finalAfrFileId` field. */
  finalAfrFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `prevYearAfrFileId` field. */
  prevYearAfrFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `prevYearDesegAfrFileId` field. */
  prevYearDesegAfrFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `prevYearFoodServiceAfrFileId` field. */
  prevYearFoodServiceAfrFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sped20FileId` field. */
  sped20FileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `sped30FileId` field. */
  sped30FileId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AccountFiscalYear` values. */
export type AccountFiscalYearsConnection = {
  __typename?: 'AccountFiscalYearsConnection';
  /** A list of edges which contains the `AccountFiscalYear` and cursor to aid in pagination. */
  edges: Array<AccountFiscalYearsEdge>;
  /** A list of `AccountFiscalYear` objects. */
  nodes: Array<AccountFiscalYear>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountFiscalYear` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountFiscalYear` edge in the connection. */
export type AccountFiscalYearsEdge = {
  __typename?: 'AccountFiscalYearsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AccountFiscalYear` at the end of the edge. */
  node: AccountFiscalYear;
};

/** Methods to use when ordering `AccountFiscalYear`. */
export enum AccountFiscalYearsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  AdoptedBudgetFileIdAsc = 'ADOPTED_BUDGET_FILE_ID_ASC',
  AdoptedBudgetFileIdDesc = 'ADOPTED_BUDGET_FILE_ID_DESC',
  Bsa21FileIdAsc = 'BSA21_FILE_ID_ASC',
  Bsa21FileIdDesc = 'BSA21_FILE_ID_DESC',
  Bsa55FileIdAsc = 'BSA55_FILE_ID_ASC',
  Bsa55FileIdDesc = 'BSA55_FILE_ID_DESC',
  Budg75FileIdAsc = 'BUDG75_FILE_ID_ASC',
  Budg75FileIdDesc = 'BUDG75_FILE_ID_DESC',
  BudgetFileIdAsc = 'BUDGET_FILE_ID_ASC',
  BudgetFileIdDesc = 'BUDGET_FILE_ID_DESC',
  BudgetRevisionExtractedDataFileIdAsc = 'BUDGET_REVISION_EXTRACTED_DATA_FILE_ID_ASC',
  BudgetRevisionExtractedDataFileIdDesc = 'BUDGET_REVISION_EXTRACTED_DATA_FILE_ID_DESC',
  ChartOfAccountsFileIdAsc = 'CHART_OF_ACCOUNTS_FILE_ID_ASC',
  ChartOfAccountsFileIdDesc = 'CHART_OF_ACCOUNTS_FILE_ID_DESC',
  DesegBudgetFileIdAsc = 'DESEG_BUDGET_FILE_ID_ASC',
  DesegBudgetFileIdDesc = 'DESEG_BUDGET_FILE_ID_DESC',
  ExternalBudgetDataFileIdAsc = 'EXTERNAL_BUDGET_DATA_FILE_ID_ASC',
  ExternalBudgetDataFileIdDesc = 'EXTERNAL_BUDGET_DATA_FILE_ID_DESC',
  ExternalBudgetRevisionDataFileIdAsc = 'EXTERNAL_BUDGET_REVISION_DATA_FILE_ID_ASC',
  ExternalBudgetRevisionDataFileIdDesc = 'EXTERNAL_BUDGET_REVISION_DATA_FILE_ID_DESC',
  FinalAfrFileIdAsc = 'FINAL_AFR_FILE_ID_ASC',
  FinalAfrFileIdDesc = 'FINAL_AFR_FILE_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  Natural = 'NATURAL',
  PrevYearAfrFileIdAsc = 'PREV_YEAR_AFR_FILE_ID_ASC',
  PrevYearAfrFileIdDesc = 'PREV_YEAR_AFR_FILE_ID_DESC',
  PrevYearDesegAfrFileIdAsc = 'PREV_YEAR_DESEG_AFR_FILE_ID_ASC',
  PrevYearDesegAfrFileIdDesc = 'PREV_YEAR_DESEG_AFR_FILE_ID_DESC',
  PrevYearFoodServiceAfrFileIdAsc = 'PREV_YEAR_FOOD_SERVICE_AFR_FILE_ID_ASC',
  PrevYearFoodServiceAfrFileIdDesc = 'PREV_YEAR_FOOD_SERVICE_AFR_FILE_ID_DESC',
  Sped20FileIdAsc = 'SPED20_FILE_ID_ASC',
  Sped20FileIdDesc = 'SPED20_FILE_ID_DESC',
  Sped30FileIdAsc = 'SPED30_FILE_ID_ASC',
  Sped30FileIdDesc = 'SPED30_FILE_ID_DESC',
}

export type AccountMember = {
  __typename?: 'AccountMember';
  avatarUrl: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
  inviteLinkId: Maybe<Scalars['UUID']>;
  membershipId: Maybe<Scalars['UUID']>;
  name: Maybe<Scalars['String']>;
  roleId: Maybe<Scalars['UUID']>;
  roleName: Maybe<Scalars['String']>;
  state: Maybe<InviteState>;
  userId: Maybe<Scalars['UUID']>;
  username: Maybe<Scalars['String']>;
};

/** A connection to a list of `AccountMember` values. */
export type AccountMembersConnection = {
  __typename?: 'AccountMembersConnection';
  /** A list of edges which contains the `AccountMember` and cursor to aid in pagination. */
  edges: Array<AccountMembersEdge>;
  /** A list of `AccountMember` objects. */
  nodes: Array<AccountMember>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountMember` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountMember` edge in the connection. */
export type AccountMembersEdge = {
  __typename?: 'AccountMembersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AccountMember` at the end of the edge. */
  node: AccountMember;
};

export type AccountMembership = {
  __typename?: 'AccountMembership';
  /** Reads a single `Account` that is related to this `AccountMembership`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** Primary key of the AccountMembership. */
  id: Scalars['UUID'];
  /** Reads a single `Role` that is related to this `AccountMembership`. */
  role: Maybe<Role>;
  roleId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `AccountMembership`. */
  user: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `AccountMembership` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountMembershipCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AccountMembership` values. */
export type AccountMembershipsConnection = {
  __typename?: 'AccountMembershipsConnection';
  /** A list of edges which contains the `AccountMembership` and cursor to aid in pagination. */
  edges: Array<AccountMembershipsEdge>;
  /** A list of `AccountMembership` objects. */
  nodes: Array<AccountMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountMembership` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountMembership` edge in the connection. */
export type AccountMembershipsEdge = {
  __typename?: 'AccountMembershipsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AccountMembership` at the end of the edge. */
  node: AccountMembership;
};

/** Methods to use when ordering `AccountMembership`. */
export enum AccountMembershipsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleIdAsc = 'ROLE_ID_ASC',
  RoleIdDesc = 'ROLE_ID_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

export enum AccountStatus {
  Active = 'ACTIVE',
  PoNoCheck = 'PO_NO_CHECK',
  Probation = 'PROBATION',
}

export type AccountUpdateSubscriptionPayload = {
  __typename?: 'AccountUpdateSubscriptionPayload';
  account: Maybe<Account>;
  event: Maybe<Scalars['String']>;
};

/** A connection to a list of `Account` values. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<AccountsEdge>;
  /** A list of `Account` objects. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Account` edge in the connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Account` at the end of the edge. */
  node: Account;
};

/** Methods to use when ordering `Account`. */
export enum AccountsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateIdAsc = 'STATE_ID_ASC',
  StateIdDesc = 'STATE_ID_DESC',
}

export type AccountsOwner = {
  __typename?: 'AccountsOwner';
  /** Reads a single `Account` that is related to this `AccountsOwner`. */
  accounts: Maybe<Account>;
  accountsId: Scalars['UUID'];
  /** The current status of this account. The status describes whether or not the account is actively owned by a user, late on a payment, or owned exclusively by the system. */
  status: AccountStatus;
};

/**
 * A condition to be used against `AccountsOwner` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountsOwnerCondition = {
  /** Checks for equality with the object’s `accountsId` field. */
  accountsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<AccountStatus>;
};

/** A connection to a list of `AccountsOwner` values. */
export type AccountsOwnersConnection = {
  __typename?: 'AccountsOwnersConnection';
  /** A list of edges which contains the `AccountsOwner` and cursor to aid in pagination. */
  edges: Array<AccountsOwnersEdge>;
  /** A list of `AccountsOwner` objects. */
  nodes: Array<AccountsOwner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountsOwner` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountsOwner` edge in the connection. */
export type AccountsOwnersEdge = {
  __typename?: 'AccountsOwnersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AccountsOwner` at the end of the edge. */
  node: AccountsOwner;
};

/** Methods to use when ordering `AccountsOwner`. */
export enum AccountsOwnersOrderBy {
  AccountsIdAsc = 'ACCOUNTS_ID_ASC',
  AccountsIdDesc = 'ACCOUNTS_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
}

export type AccountsSystem = {
  __typename?: 'AccountsSystem';
  /** Reads a single `Account` that is related to this `AccountsSystem`. */
  accounts: Maybe<Account>;
  accountsId: Scalars['UUID'];
  /** The unique identifier in the payment processor that relates to this account. */
  paymentProcessorAccountId: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `AccountsSystem` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AccountsSystemCondition = {
  /** Checks for equality with the object’s `accountsId` field. */
  accountsId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AccountsSystem` values. */
export type AccountsSystemsConnection = {
  __typename?: 'AccountsSystemsConnection';
  /** A list of edges which contains the `AccountsSystem` and cursor to aid in pagination. */
  edges: Array<AccountsSystemsEdge>;
  /** A list of `AccountsSystem` objects. */
  nodes: Array<AccountsSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountsSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AccountsSystem` edge in the connection. */
export type AccountsSystemsEdge = {
  __typename?: 'AccountsSystemsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AccountsSystem` at the end of the edge. */
  node: AccountsSystem;
};

/** Methods to use when ordering `AccountsSystem`. */
export enum AccountsSystemsOrderBy {
  AccountsIdAsc = 'ACCOUNTS_ID_ASC',
  AccountsIdDesc = 'ACCOUNTS_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/** All input for the `acknowledgeNotification` mutation. */
export type AcknowledgeNotificationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  notificationId: Scalars['UUID'];
};

/** The output of our `acknowledgeNotification` mutation. */
export type AcknowledgeNotificationPayload = {
  __typename?: 'AcknowledgeNotificationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type AiDocument = {
  __typename?: 'AiDocument';
  /** Reads a single `Account` that is related to this `AiDocument`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `AiDocumentEmbedding`. */
  aiDocumentEmbeddingsByDocumentId: AiDocumentEmbeddingsConnection;
  /** SHA-256 hash of the content for change detection. */
  contentHash: Maybe<Scalars['String']>;
  /** The time that this AiDocument was created. */
  createdAt: Scalars['Datetime'];
  /** The kind of document that was scraped. */
  documentType: Scalars['String'];
  /** Error detail recorded when processing fails. */
  errorMessage: Maybe<Scalars['String']>;
  /** Reads a single `FiscalYear` that is related to this `AiDocument`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Path to the stored raw document in Google Cloud Storage. */
  gcsPath: Scalars['String'];
  /** Primary key of the AiDocument. */
  id: Scalars['UUID'];
  /** When this document was most recently scraped. */
  lastScrapedAt: Maybe<Scalars['Datetime']>;
  /** The URL the document was scraped from. */
  sourceUrl: Scalars['String'];
  /** Processing status of the document. */
  status: Scalars['String'];
  /** Human-readable title of the document, if known. */
  title: Maybe<Scalars['String']>;
  /** The time that this AiDocument was last updated. */
  updatedAt: Scalars['Datetime'];
};

export type AiDocumentAiDocumentEmbeddingsByDocumentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentEmbeddingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentEmbeddingsOrderBy>>;
};

/**
 * A condition to be used against `AiDocument` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AiDocumentCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

export type AiDocumentEmbedding = {
  __typename?: 'AiDocumentEmbedding';
  /** Reads a single `Account` that is related to this `AiDocumentEmbedding`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** Zero-based position of this chunk within the document. */
  chunkIndex: Scalars['Int'];
  /** The text content of this chunk. */
  chunkText: Scalars['String'];
  /** The time that this AiDocumentEmbedding was created. */
  createdAt: Scalars['Datetime'];
  /** Reads a single `AiDocument` that is related to this `AiDocumentEmbedding`. */
  document: Maybe<AiDocument>;
  documentId: Scalars['UUID'];
  /** Embedding vector (Voyage AI 1024 dimensions). */
  embedding: Scalars['String'];
  /** Reads a single `FiscalYear` that is related to this `AiDocumentEmbedding`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the AiDocumentEmbedding. */
  id: Scalars['UUID'];
  /** Chunk metadata such as page number or section title. */
  metadata: Maybe<Scalars['JSON']>;
};

/**
 * A condition to be used against `AiDocumentEmbedding` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AiDocumentEmbeddingCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `documentId` field. */
  documentId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `embedding` field. */
  embedding?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AiDocumentEmbedding` values. */
export type AiDocumentEmbeddingsConnection = {
  __typename?: 'AiDocumentEmbeddingsConnection';
  /** A list of edges which contains the `AiDocumentEmbedding` and cursor to aid in pagination. */
  edges: Array<AiDocumentEmbeddingsEdge>;
  /** A list of `AiDocumentEmbedding` objects. */
  nodes: Array<AiDocumentEmbedding>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AiDocumentEmbedding` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AiDocumentEmbedding` edge in the connection. */
export type AiDocumentEmbeddingsEdge = {
  __typename?: 'AiDocumentEmbeddingsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AiDocumentEmbedding` at the end of the edge. */
  node: AiDocumentEmbedding;
};

/** Methods to use when ordering `AiDocumentEmbedding`. */
export enum AiDocumentEmbeddingsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  DocumentIdAsc = 'DOCUMENT_ID_ASC',
  DocumentIdDesc = 'DOCUMENT_ID_DESC',
  EmbeddingAsc = 'EMBEDDING_ASC',
  EmbeddingDesc = 'EMBEDDING_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type AiDocumentSource = {
  __typename?: 'AiDocumentSource';
  /** Reads a single `Account` that is related to this `AiDocumentSource`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** The time that this AiDocumentSource was created. */
  createdAt: Scalars['Datetime'];
  /** The kind of document expected at this source. */
  documentType: Scalars['String'];
  /** Allows disabling a source without deleting it. */
  enabled: Scalars['Boolean'];
  /** Reads a single `FiscalYear` that is related to this `AiDocumentSource`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the AiDocumentSource. */
  id: Scalars['UUID'];
  /** When this source was most recently scraped. */
  lastScrapedAt: Maybe<Scalars['Datetime']>;
  /** How often to re-scrape this source, in hours. */
  scrapeIntervalHours: Scalars['Int'];
  /** The URL to scrape documents from. */
  sourceUrl: Scalars['String'];
  /** Human-readable label for this source. */
  title: Maybe<Scalars['String']>;
  /** The time that this AiDocumentSource was last updated. */
  updatedAt: Scalars['Datetime'];
};

/**
 * A condition to be used against `AiDocumentSource` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AiDocumentSourceCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AiDocumentSource` values. */
export type AiDocumentSourcesConnection = {
  __typename?: 'AiDocumentSourcesConnection';
  /** A list of edges which contains the `AiDocumentSource` and cursor to aid in pagination. */
  edges: Array<AiDocumentSourcesEdge>;
  /** A list of `AiDocumentSource` objects. */
  nodes: Array<AiDocumentSource>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AiDocumentSource` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AiDocumentSource` edge in the connection. */
export type AiDocumentSourcesEdge = {
  __typename?: 'AiDocumentSourcesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AiDocumentSource` at the end of the edge. */
  node: AiDocumentSource;
};

/** Methods to use when ordering `AiDocumentSource`. */
export enum AiDocumentSourcesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/** A connection to a list of `AiDocument` values. */
export type AiDocumentsConnection = {
  __typename?: 'AiDocumentsConnection';
  /** A list of edges which contains the `AiDocument` and cursor to aid in pagination. */
  edges: Array<AiDocumentsEdge>;
  /** A list of `AiDocument` objects. */
  nodes: Array<AiDocument>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AiDocument` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AiDocument` edge in the connection. */
export type AiDocumentsEdge = {
  __typename?: 'AiDocumentsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AiDocument` at the end of the edge. */
  node: AiDocument;
};

/** Methods to use when ordering `AiDocument`. */
export enum AiDocumentsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type AiUsageConfig = {
  __typename?: 'AiUsageConfig';
  /** Reads a single `Account` that is related to this `AiUsageConfig`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** The time that this AiUsageConfig was created. */
  createdAt: Scalars['Datetime'];
  /** When true, disables the AI Assistant for this district only. */
  districtKillSwitch: Scalars['Boolean'];
  /** When true, disables the AI Assistant for every district. */
  globalKillSwitch: Scalars['Boolean'];
  /** Primary key of the AiUsageConfig. */
  id: Scalars['UUID'];
  /** The time that this AiUsageConfig was last updated. */
  updatedAt: Scalars['Datetime'];
  /** Per usage_period spend limit in cents. NULL means no limit. */
  usageLimitCents: Maybe<Scalars['Int']>;
  /** The window the usage limit applies to. */
  usagePeriodType: Scalars['String'];
};

/**
 * A condition to be used against `AiUsageConfig` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AiUsageConfigCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AiUsageConfig` values. */
export type AiUsageConfigsConnection = {
  __typename?: 'AiUsageConfigsConnection';
  /** A list of edges which contains the `AiUsageConfig` and cursor to aid in pagination. */
  edges: Array<AiUsageConfigsEdge>;
  /** A list of `AiUsageConfig` objects. */
  nodes: Array<AiUsageConfig>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AiUsageConfig` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AiUsageConfig` edge in the connection. */
export type AiUsageConfigsEdge = {
  __typename?: 'AiUsageConfigsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AiUsageConfig` at the end of the edge. */
  node: AiUsageConfig;
};

/** Methods to use when ordering `AiUsageConfig`. */
export enum AiUsageConfigsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type AiUsageLog = {
  __typename?: 'AiUsageLog';
  /** Reads a single `Account` that is related to this `AiUsageLog`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** The time that this AiUsageLog was created. */
  createdAt: Scalars['Datetime'];
  /** Estimated cost of the request, in cents for precision. */
  estimatedCostCents: Scalars['Int'];
  /** Primary key of the AiUsageLog. */
  id: Scalars['UUID'];
  /** The model identifier used for the request. */
  model: Scalars['String'];
  /** The kind of AI request this log entry represents. */
  requestType: Scalars['String'];
  /** Input tokens consumed by the request. */
  tokensIn: Scalars['Int'];
  /** Output tokens produced by the request. */
  tokensOut: Scalars['Int'];
  /** Billing period as 'YYYY-MM', aligned with vendor billing. */
  usagePeriod: Scalars['String'];
  /** The user who made the request. */
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `AiUsageLog` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type AiUsageLogCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `AiUsageLog` values. */
export type AiUsageLogsConnection = {
  __typename?: 'AiUsageLogsConnection';
  /** A list of edges which contains the `AiUsageLog` and cursor to aid in pagination. */
  edges: Array<AiUsageLogsEdge>;
  /** A list of `AiUsageLog` objects. */
  nodes: Array<AiUsageLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AiUsageLog` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `AiUsageLog` edge in the connection. */
export type AiUsageLogsEdge = {
  __typename?: 'AiUsageLogsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `AiUsageLog` at the end of the edge. */
  node: AiUsageLog;
};

/** Methods to use when ordering `AiUsageLog`. */
export enum AiUsageLogsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type BuildScrapeUploadUrlInput = {
  /** The account the report belongs to. */
  accountId: Scalars['UUID'];
  /** The fiscal year the report belongs to. */
  fiscalYearId: Scalars['UUID'];
  /** The signed token; identifies the run on its own. */
  runToken: Scalars['String'];
  /** Which report section this file is (see document-sections.ts). */
  sectionKey: Scalars['String'];
};

export type BuildSignedUrlForAccountInput = {
  /** The account ID to upload files for. */
  accountId: Scalars['UUID'];
  /** The details of the file to upload. */
  fileDetails: FileDetails;
  /** The fiscal year ID to upload files for. */
  fiscalYearId: Scalars['UUID'];
  /** The type of file to upload. */
  type: BuildSignedUrlForAccountType;
};

export enum BuildSignedUrlForAccountType {
  /** Adopted Budget */
  AdoptedBudget = 'ADOPTED_BUDGET',
  /** BSA21 */
  Bsa21 = 'BSA21',
  /** BUDG75 */
  Budg75 = 'BUDG75',
  /** Budget file */
  Budget = 'BUDGET',
  /** Chart of Accounts file */
  ChartOfAccounts = 'CHART_OF_ACCOUNTS',
  /** Deseg Budget file */
  DesegBudget = 'DESEG_BUDGET',
  /** External Budget Data file */
  ExternalBudgetData = 'EXTERNAL_BUDGET_DATA',
  /** External Budget Revision Data file */
  ExternalBudgetRevisionData = 'EXTERNAL_BUDGET_REVISION_DATA',
  /** Final AFR */
  FinalAfr = 'FINAL_AFR',
  /** Prev Year AFR */
  PrevYearAfr = 'PREV_YEAR_AFR',
  /** Prev Year Deseg AFR */
  PrevYearDesegAfr = 'PREV_YEAR_DESEG_AFR',
  /** Prev Year Food Service AFR */
  PrevYearFoodServiceAfr = 'PREV_YEAR_FOOD_SERVICE_AFR',
  /** SPED20 file */
  Sped20 = 'SPED20',
  /** SPED30 file */
  Sped30 = 'SPED30',
}

export type BuildSignedUrlForLedgerInput = {
  /** The details of the file to upload. */
  fileDetails: FileDetails;
  /** The general ledger ID to upload files for. */
  ledgerId: Scalars['UUID'];
  /** The type of file to upload. */
  type: BuildSignedUrlForLedgerType;
};

export enum BuildSignedUrlForLedgerType {
  /** General Ledger file */
  GeneralLedger = 'GENERAL_LEDGER',
  /** SPED20 file */
  Sped20 = 'SPED20',
  /** SPED30 file */
  Sped30 = 'SPED30',
}

/** All input for the `changeMemberRole` mutation. */
export type ChangeMemberRoleInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  membershipId: Scalars['UUID'];
  roleId: Scalars['UUID'];
};

/** The output of our `changeMemberRole` mutation. */
export type ChangeMemberRolePayload = {
  __typename?: 'ChangeMemberRolePayload';
  /** Reads a single `Account` that is related to this `AccountMembership`. */
  account: Maybe<Account>;
  accountMembership: Maybe<AccountMembership>;
  /** An edge for our `AccountMembership`. May be used by Relay 1. */
  accountMembershipEdge: Maybe<AccountMembershipsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Role` that is related to this `AccountMembership`. */
  role: Maybe<Role>;
  /** Reads a single `User` that is related to this `AccountMembership`. */
  user: Maybe<User>;
};

/** The output of our `changeMemberRole` mutation. */
export type ChangeMemberRolePayloadAccountMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountMembershipsOrderBy>>;
};

/** All input for the `changeUserEmail` mutation. */
export type ChangeUserEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailUuid: Scalars['String'];
  newEmail: Scalars['String'];
};

/** The output of our `changeUserEmail` mutation. */
export type ChangeUserEmailPayload = {
  __typename?: 'ChangeUserEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type CodeCheckCustomization = {
  __typename?: 'CodeCheckCustomization';
  /** Reads a single `Account` that is related to this `CodeCheckCustomization`. */
  account: Maybe<Account>;
  /** The regular expression used to break this districts account codes into the parts necessary for a code check. */
  accountCodeParserRegex: Maybe<Scalars['String']>;
  accountId: Scalars['UUID'];
  /** The regular expression used to determine which records should have the amount negated during normalization before a code check. */
  amountNegationRegex: Maybe<Scalars['String']>;
  /** Reads a single `FiscalYear` that is related to this `CodeCheckCustomization`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the CodeCheckCustomization. */
  id: Scalars['UUID'];
};

/**
 * A condition to be used against `CodeCheckCustomization` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type CodeCheckCustomizationCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `CodeCheckCustomization` values. */
export type CodeCheckCustomizationsConnection = {
  __typename?: 'CodeCheckCustomizationsConnection';
  /** A list of edges which contains the `CodeCheckCustomization` and cursor to aid in pagination. */
  edges: Array<CodeCheckCustomizationsEdge>;
  /** A list of `CodeCheckCustomization` objects. */
  nodes: Array<CodeCheckCustomization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CodeCheckCustomization` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CodeCheckCustomization` edge in the connection. */
export type CodeCheckCustomizationsEdge = {
  __typename?: 'CodeCheckCustomizationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `CodeCheckCustomization` at the end of the edge. */
  node: CodeCheckCustomization;
};

/** Methods to use when ordering `CodeCheckCustomization`. */
export enum CodeCheckCustomizationsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type CodeCheckResult = {
  __typename?: 'CodeCheckResult';
  /** The cost or revenue amount in the currency's smallest unit */
  amount: Scalars['BigInt'];
  /** The classification of the code check result. This is used to group code checks into categories. */
  classification: Maybe<Scalars['String']>;
  /** The Description */
  description: Scalars['String'];
  /** Details about the code check rendered in markdown. */
  details: Scalars['String'];
  /** Reads a single `GeneralLedger` that is related to this `CodeCheckResult`. */
  generalLedger: Maybe<GeneralLedger>;
  generalLedgerId: Maybe<Scalars['UUID']>;
  /** The original account code without any modifications. */
  originalAccountCode: Scalars['String'];
  /** The severity of the code check result. */
  severity: CodeCheckResultSeverity;
  /** The source line of the original file where this result was found */
  sourceLine: Scalars['Int'];
};

/**
 * A condition to be used against `CodeCheckResult` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CodeCheckResultCondition = {
  /** Checks for equality with the object’s `classification` field. */
  classification?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `generalLedgerId` field. */
  generalLedgerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `severity` field. */
  severity?: InputMaybe<CodeCheckResultSeverity>;
};

export enum CodeCheckResultSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING',
}

/** A connection to a list of `CodeCheckResult` values. */
export type CodeCheckResultsConnection = {
  __typename?: 'CodeCheckResultsConnection';
  /** A list of edges which contains the `CodeCheckResult` and cursor to aid in pagination. */
  edges: Array<CodeCheckResultsEdge>;
  /** A list of `CodeCheckResult` objects. */
  nodes: Array<CodeCheckResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CodeCheckResult` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `CodeCheckResult` edge in the connection. */
export type CodeCheckResultsEdge = {
  __typename?: 'CodeCheckResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `CodeCheckResult` at the end of the edge. */
  node: CodeCheckResult;
};

/** Methods to use when ordering `CodeCheckResult`. */
export enum CodeCheckResultsOrderBy {
  ClassificationAsc = 'CLASSIFICATION_ASC',
  ClassificationDesc = 'CLASSIFICATION_DESC',
  GeneralLedgerIdAsc = 'GENERAL_LEDGER_ID_ASC',
  GeneralLedgerIdDesc = 'GENERAL_LEDGER_ID_DESC',
  Natural = 'NATURAL',
  SeverityAsc = 'SEVERITY_ASC',
  SeverityDesc = 'SEVERITY_DESC',
}

export type CompleteScrapeAttemptInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** True when the run produced nothing usable. */
  failed?: InputMaybe<Scalars['Boolean']>;
  /** Per-section outcomes. Uploaded sections are ingested server-side. */
  results: Scalars['JSON'];
  runToken: Scalars['String'];
};

export type CompleteScrapeAttemptPayload = {
  __typename?: 'CompleteScrapeAttemptPayload';
  clientMutationId: Maybe<Scalars['String']>;
  ingested: Scalars['Int'];
};

/** All input for the `confirmAccountDeletion` mutation. */
export type ConfirmAccountDeletionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};

/** The output of our `confirmAccountDeletion` mutation. */
export type ConfirmAccountDeletionPayload = {
  __typename?: 'ConfirmAccountDeletionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

/** All input for the `createAccount` mutation. */
export type CreateAccountInput = {
  accountName: Scalars['String'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  stateId: Scalars['UUID'];
};

/** The output of our `createAccount` mutation. */
export type CreateAccountPayload = {
  __typename?: 'CreateAccountPayload';
  account: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge: Maybe<AccountsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `State` that is related to this `Account`. */
  state: Maybe<State>;
};

/** The output of our `createAccount` mutation. */
export type CreateAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `createGeneralLedger` mutation. */
export type CreateGeneralLedgerInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  fiscalYear: Scalars['Int'];
  ledgerStatus: GeneralLedgerStatus;
  useNewSalaryRules?: InputMaybe<Scalars['Boolean']>;
};

/** The output of our `createGeneralLedger` mutation. */
export type CreateGeneralLedgerPayload = {
  __typename?: 'CreateGeneralLedgerPayload';
  /** Reads a single `Account` that is related to this `GeneralLedger`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `FiscalYear` that is related to this `GeneralLedger`. */
  fiscalYear: Maybe<FiscalYear>;
  generalLedger: Maybe<GeneralLedger>;
  /** An edge for our `GeneralLedger`. May be used by Relay 1. */
  generalLedgerEdge: Maybe<GeneralLedgersEdge>;
  /** Reads a single `File` that is related to this `GeneralLedger`. */
  generalLedgerFile: Maybe<File>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `User` that is related to this `GeneralLedger`. */
  user: Maybe<User>;
};

/** The output of our `createGeneralLedger` mutation. */
export type CreateGeneralLedgerPayloadGeneralLedgerEdgeArgs = {
  orderBy?: InputMaybe<Array<GeneralLedgersOrderBy>>;
};

/** All input for the `deleteDistrictContact` mutation. */
export type DeleteDistrictContactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId: Scalars['UUID'];
};

/** The output of our `deleteDistrictContact` mutation. */
export type DeleteDistrictContactPayload = {
  __typename?: 'DeleteDistrictContactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

/** All input for the `deleteSchool` mutation. */
export type DeleteSchoolInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  schoolId: Scalars['UUID'];
};

/** The output of our `deleteSchool` mutation. */
export type DeleteSchoolPayload = {
  __typename?: 'DeleteSchoolPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type DistrictCoaSegment = {
  __typename?: 'DistrictCoaSegment';
  /** Reads a single `Account` that is related to this `DistrictCoaSegment`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** The time that this DistrictCoaSegment was created. */
  createdAt: Scalars['Datetime'];
  /** Number of digits in this segment (1-10). */
  digitCount: Scalars['Int'];
  /** Reads and enables pagination through a set of `DistrictCodeOption`. */
  districtCodeOptionsBySegmentId: DistrictCodeOptionsConnection;
  /** Reads a single `FiscalYear` that is related to this `DistrictCoaSegment`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the DistrictCoaSegment. */
  id: Scalars['UUID'];
  /** True for the four USFR base sections (fund, program, function, object); false for district-specific extras. */
  isBaseSegment: Scalars['Boolean'];
  /** The name of this account-code segment. */
  segmentName: Scalars['String'];
  /** Display order: determines left-to-right placement in the generated account code. */
  sortOrder: Scalars['Int'];
};

export type DistrictCoaSegmentDistrictCodeOptionsBySegmentIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictCodeOptionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictCodeOptionsOrderBy>>;
};

/**
 * A condition to be used against `DistrictCoaSegment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DistrictCoaSegmentCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `DistrictCoaSegment` values. */
export type DistrictCoaSegmentsConnection = {
  __typename?: 'DistrictCoaSegmentsConnection';
  /** A list of edges which contains the `DistrictCoaSegment` and cursor to aid in pagination. */
  edges: Array<DistrictCoaSegmentsEdge>;
  /** A list of `DistrictCoaSegment` objects. */
  nodes: Array<DistrictCoaSegment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DistrictCoaSegment` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DistrictCoaSegment` edge in the connection. */
export type DistrictCoaSegmentsEdge = {
  __typename?: 'DistrictCoaSegmentsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `DistrictCoaSegment` at the end of the edge. */
  node: DistrictCoaSegment;
};

/** Methods to use when ordering `DistrictCoaSegment`. */
export enum DistrictCoaSegmentsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type DistrictCodeOption = {
  __typename?: 'DistrictCodeOption';
  /** Reads a single `Account` that is related to this `DistrictCodeOption`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** The numeric code value (e.g. "001" or "1000"). */
  codeValue: Scalars['String'];
  /** The time that this DistrictCodeOption was created. */
  createdAt: Scalars['Datetime'];
  /** Human-readable description of the code option. */
  description: Maybe<Scalars['String']>;
  /** Reads a single `FiscalYear` that is related to this `DistrictCodeOption`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the DistrictCodeOption. */
  id: Scalars['UUID'];
  /** Reads a single `DistrictCoaSegment` that is related to this `DistrictCodeOption`. */
  segment: Maybe<DistrictCoaSegment>;
  segmentId: Scalars['UUID'];
};

/**
 * A condition to be used against `DistrictCodeOption` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DistrictCodeOptionCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `segmentId` field. */
  segmentId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `DistrictCodeOption` values. */
export type DistrictCodeOptionsConnection = {
  __typename?: 'DistrictCodeOptionsConnection';
  /** A list of edges which contains the `DistrictCodeOption` and cursor to aid in pagination. */
  edges: Array<DistrictCodeOptionsEdge>;
  /** A list of `DistrictCodeOption` objects. */
  nodes: Array<DistrictCodeOption>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DistrictCodeOption` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DistrictCodeOption` edge in the connection. */
export type DistrictCodeOptionsEdge = {
  __typename?: 'DistrictCodeOptionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `DistrictCodeOption` at the end of the edge. */
  node: DistrictCodeOption;
};

/** Methods to use when ordering `DistrictCodeOption`. */
export enum DistrictCodeOptionsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SegmentIdAsc = 'SEGMENT_ID_ASC',
  SegmentIdDesc = 'SEGMENT_ID_DESC',
}

export type DistrictContact = {
  __typename?: 'DistrictContact';
  /** Reads a single `Account` that is related to this `DistrictContact`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** The time that this DistrictContact was created. */
  createdAt: Scalars['Datetime'];
  /** The email address of the district contact. */
  email: Maybe<Scalars['String']>;
  /** The phone number extension of the district contact. */
  extension: Maybe<Scalars['String']>;
  /** The first name of the district contact. */
  firstName: Scalars['String'];
  /** Reads a single `FiscalYear` that is related to this `DistrictContact`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the DistrictContact. */
  id: Scalars['UUID'];
  /** The last name of the district contact. */
  lastName: Scalars['String'];
  /** The phone number of the district contact. */
  phone: Maybe<Scalars['String']>;
  /** The name prefix of the district contact. */
  prefix: Maybe<Scalars['String']>;
  /** The job title of the district contact. */
  title: Scalars['String'];
};

/**
 * A condition to be used against `DistrictContact` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DistrictContactCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `DistrictContact` values. */
export type DistrictContactsConnection = {
  __typename?: 'DistrictContactsConnection';
  /** A list of edges which contains the `DistrictContact` and cursor to aid in pagination. */
  edges: Array<DistrictContactsEdge>;
  /** A list of `DistrictContact` objects. */
  nodes: Array<DistrictContact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DistrictContact` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `DistrictContact` edge in the connection. */
export type DistrictContactsEdge = {
  __typename?: 'DistrictContactsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `DistrictContact` at the end of the edge. */
  node: DistrictContact;
};

/** Methods to use when ordering `DistrictContact`. */
export enum DistrictContactsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/** All input for the `extractBudgetDataForYear` mutation. */
export type ExtractBudgetDataForYearInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fiscalYearId: Scalars['UUID'];
};

/** The output of our `extractBudgetDataForYear` mutation. */
export type ExtractBudgetDataForYearPayload = {
  __typename?: 'ExtractBudgetDataForYearPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type Feature = {
  __typename?: 'Feature';
  /** Reads and enables pagination through a set of `AccountFeature`. */
  accountFeatures: AccountFeaturesConnection;
  /** Primary key of the Features. */
  id: Scalars['UUID'];
  /** The name of the feature. */
  name: Scalars['String'];
  /** This is the scope selector for the feature. If this feature is not enabled, the matched scopes will be disabled. */
  scopeSelector: Scalars['String'];
};

export type FeatureAccountFeaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFeatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFeaturesOrderBy>>;
};

/** A condition to be used against `Feature` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FeatureCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Feature` values. */
export type FeaturesConnection = {
  __typename?: 'FeaturesConnection';
  /** A list of edges which contains the `Feature` and cursor to aid in pagination. */
  edges: Array<FeaturesEdge>;
  /** A list of `Feature` objects. */
  nodes: Array<Feature>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Feature` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Feature` edge in the connection. */
export type FeaturesEdge = {
  __typename?: 'FeaturesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Feature` at the end of the edge. */
  node: Feature;
};

/** Methods to use when ordering `Feature`. */
export enum FeaturesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type File = {
  __typename?: 'File';
  /** Reads a single `Account` that is related to this `File`. */
  account: Maybe<Account>;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByAdoptedBudgetFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByBsa21FileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByBsa55FileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByBudg75FileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByBudgetFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByBudgetRevisionExtractedDataFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByChartOfAccountsFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByDesegBudgetFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByExternalBudgetDataFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByExternalBudgetRevisionDataFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByFinalAfrFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByPrevYearAfrFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByPrevYearDesegAfrFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsByPrevYearFoodServiceAfrFileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsBySped20FileId: AccountFiscalYearsConnection;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYearsBySped30FileId: AccountFiscalYearsConnection;
  accountId: Scalars['UUID'];
  /** Describes why background parsing of the file failed. Null unless status is 'error'. */
  errorMessage: Maybe<Scalars['String']>;
  /** The original extension attached to the file when it was uploaded. Should include the leading period. */
  extension: Maybe<Scalars['String']>;
  /** Data extracted from the file for easy use/display within Nextgen. */
  extractedData: Maybe<Scalars['JSON']>;
  /** Reads a single `FilesSystem` that is related to this `File`. */
  filesSystemByFilesId: Maybe<FilesSystem>;
  /** Reads and enables pagination through a set of `GeneralLedger`. */
  generalLedgersByGeneralLedgerFileId: GeneralLedgersConnection;
  /** Primary key of the File. */
  id: Scalars['UUID'];
  /** The original name of the file when it was uploaded. Should not include the extension. */
  name: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Report`. */
  reportsByReportFileId: ReportsConnection;
  /** The size of the file in bytes. */
  size: Scalars['BigInt'];
  /** Processing status for files parsed by a background job (e.g. Chart of Accounts): 'pending', 'processing', 'completed', or 'error'. Null for files that are not asynchronously parsed. */
  status: Maybe<Scalars['String']>;
  /** Whether or not the file has been uploaded by the client to our storage bucket. */
  uploaded: Scalars['Boolean'];
  /** The URL where the file is hosted for internal use. */
  url: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `File`. */
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']>;
};

export type FileAccountFiscalYearsByAdoptedBudgetFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByBsa21FileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByBsa55FileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByBudg75FileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByBudgetFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByBudgetRevisionExtractedDataFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByChartOfAccountsFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByDesegBudgetFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByExternalBudgetDataFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByExternalBudgetRevisionDataFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByFinalAfrFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByPrevYearAfrFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByPrevYearDesegAfrFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsByPrevYearFoodServiceAfrFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsBySped20FileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileAccountFiscalYearsBySped30FileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FileGeneralLedgersByGeneralLedgerFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GeneralLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeneralLedgersOrderBy>>;
};

export type FileReportsByReportFileIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/** A condition to be used against `File` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type FileCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export type FileDetails = {
  /** The content type of the file, eg. application/json */
  contentType: Scalars['String'];
  /** The original filename that needs to be uploaded. */
  filename: Scalars['String'];
  /** The md5 hash of the file contents */
  md5Hash: Scalars['String'];
  /**
   * The size of the file in bytes. Required for file types that
   * enforce a maximum upload size (eg. CHART_OF_ACCOUNTS).
   */
  size?: InputMaybe<Scalars['Int']>;
};

export type FileTemplateVersion = {
  __typename?: 'FileTemplateVersion';
  /** The date of the AFR file. */
  afrDate: Scalars['Datetime'];
  /** The version of the AFR file. */
  afrVersion: Scalars['String'];
  /** Reads a single `FiscalYear` that is related to this `FileTemplateVersion`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the File Template Versions. */
  id: Scalars['UUID'];
  /** Any notes or comments about the file version. */
  memo: Scalars['String'];
  /** Reads and enables pagination through a set of `Report`. */
  reports: ReportsConnection;
  /** The date of the SL file. */
  slDate: Scalars['Datetime'];
  /** The version of the SL file. */
  slVersion: Scalars['String'];
  /** Reads a single `State` that is related to this `FileTemplateVersion`. */
  state: Maybe<State>;
  stateId: Scalars['UUID'];
  /** The date of the system. */
  systemDate: Scalars['Datetime'];
  /** The version of the system. */
  systemVersion: Scalars['Int'];
};

export type FileTemplateVersionReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/**
 * A condition to be used against `FileTemplateVersion` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type FileTemplateVersionCondition = {
  /** Checks for equality with the object’s `afrVersion` field. */
  afrVersion?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stateId` field. */
  stateId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `systemVersion` field. */
  systemVersion?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `FileTemplateVersion` values. */
export type FileTemplateVersionsConnection = {
  __typename?: 'FileTemplateVersionsConnection';
  /** A list of edges which contains the `FileTemplateVersion` and cursor to aid in pagination. */
  edges: Array<FileTemplateVersionsEdge>;
  /** A list of `FileTemplateVersion` objects. */
  nodes: Array<FileTemplateVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FileTemplateVersion` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FileTemplateVersion` edge in the connection. */
export type FileTemplateVersionsEdge = {
  __typename?: 'FileTemplateVersionsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `FileTemplateVersion` at the end of the edge. */
  node: FileTemplateVersion;
};

/** Methods to use when ordering `FileTemplateVersion`. */
export enum FileTemplateVersionsOrderBy {
  AfrVersionAsc = 'AFR_VERSION_ASC',
  AfrVersionDesc = 'AFR_VERSION_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  StateIdAsc = 'STATE_ID_ASC',
  StateIdDesc = 'STATE_ID_DESC',
  SystemVersionAsc = 'SYSTEM_VERSION_ASC',
  SystemVersionDesc = 'SYSTEM_VERSION_DESC',
}

/** A connection to a list of `File` values. */
export type FilesConnection = {
  __typename?: 'FilesConnection';
  /** A list of edges which contains the `File` and cursor to aid in pagination. */
  edges: Array<FilesEdge>;
  /** A list of `File` objects. */
  nodes: Array<File>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `File` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `File` edge in the connection. */
export type FilesEdge = {
  __typename?: 'FilesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `File` at the end of the edge. */
  node: File;
};

/** Methods to use when ordering `File`. */
export enum FilesOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

export type FilesSystem = {
  __typename?: 'FilesSystem';
  /** Reads a single `File` that is related to this `FilesSystem`. */
  files: Maybe<File>;
  filesId: Scalars['UUID'];
  /** The URL where the file is hosted for internal use. */
  url: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `FilesSystem` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FilesSystemCondition = {
  /** Checks for equality with the object’s `filesId` field. */
  filesId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `FilesSystem` values. */
export type FilesSystemsConnection = {
  __typename?: 'FilesSystemsConnection';
  /** A list of edges which contains the `FilesSystem` and cursor to aid in pagination. */
  edges: Array<FilesSystemsEdge>;
  /** A list of `FilesSystem` objects. */
  nodes: Array<FilesSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FilesSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FilesSystem` edge in the connection. */
export type FilesSystemsEdge = {
  __typename?: 'FilesSystemsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `FilesSystem` at the end of the edge. */
  node: FilesSystem;
};

/** Methods to use when ordering `FilesSystem`. */
export enum FilesSystemsOrderBy {
  FilesIdAsc = 'FILES_ID_ASC',
  FilesIdDesc = 'FILES_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type FiscalYear = {
  __typename?: 'FiscalYear';
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYears: AccountFiscalYearsConnection;
  /** Whether or not this fiscal year is active for regular users in the system. */
  active: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `AiDocumentEmbedding`. */
  aiDocumentEmbeddings: AiDocumentEmbeddingsConnection;
  /** Reads and enables pagination through a set of `AiDocumentSource`. */
  aiDocumentSources: AiDocumentSourcesConnection;
  /** Reads and enables pagination through a set of `AiDocument`. */
  aiDocuments: AiDocumentsConnection;
  /** Whether or not this fiscal year is in budget revision mode. If true, the fiscal year is in budget revision mode, which means the budget tool will help revise budgets rather than propose them. */
  budgetRevisionMode: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `CodeCheckCustomization`. */
  codeCheckCustomizations: CodeCheckCustomizationsConnection;
  /** Reads and enables pagination through a set of `DistrictCoaSegment`. */
  districtCoaSegments: DistrictCoaSegmentsConnection;
  /** Reads and enables pagination through a set of `DistrictCodeOption`. */
  districtCodeOptions: DistrictCodeOptionsConnection;
  /** Reads and enables pagination through a set of `DistrictContact`. */
  districtContacts: DistrictContactsConnection;
  /** Reads and enables pagination through a set of `FileTemplateVersion`. */
  fileTemplateVersions: FileTemplateVersionsConnection;
  /** Reads and enables pagination through a set of `FutureJob`. */
  futureJobs: FutureJobsConnection;
  /** Reads and enables pagination through a set of `GeneralLedger`. */
  generalLedgers: GeneralLedgersConnection;
  /** Primary key of the FiscalYear. */
  id: Scalars['UUID'];
  /** Whether or not this fiscal year is in preview mode. At the time of writing, this means that users can only submit draft ledgers for this fiscal year. */
  preview: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `Report`. */
  reports: ReportsConnection;
  /** Reads and enables pagination through a set of `School`. */
  schools: SchoolsConnection;
  /** The value describing this fiscal year. */
  value: Scalars['Int'];
};

export type FiscalYearAccountFiscalYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

export type FiscalYearAiDocumentEmbeddingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentEmbeddingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentEmbeddingsOrderBy>>;
};

export type FiscalYearAiDocumentSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentSourceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentSourcesOrderBy>>;
};

export type FiscalYearAiDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentsOrderBy>>;
};

export type FiscalYearCodeCheckCustomizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CodeCheckCustomizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CodeCheckCustomizationsOrderBy>>;
};

export type FiscalYearDistrictCoaSegmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictCoaSegmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictCoaSegmentsOrderBy>>;
};

export type FiscalYearDistrictCodeOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictCodeOptionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictCodeOptionsOrderBy>>;
};

export type FiscalYearDistrictContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictContactsOrderBy>>;
};

export type FiscalYearFileTemplateVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FileTemplateVersionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileTemplateVersionsOrderBy>>;
};

export type FiscalYearFutureJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureJobCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureJobsOrderBy>>;
};

export type FiscalYearGeneralLedgersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GeneralLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeneralLedgersOrderBy>>;
};

export type FiscalYearReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

export type FiscalYearSchoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SchoolCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SchoolsOrderBy>>;
};

/**
 * A condition to be used against `FiscalYear` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FiscalYearCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `budgetRevisionMode` field. */
  budgetRevisionMode?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `preview` field. */
  preview?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `value` field. */
  value?: InputMaybe<Scalars['Int']>;
};

/** A connection to a list of `FiscalYear` values. */
export type FiscalYearsConnection = {
  __typename?: 'FiscalYearsConnection';
  /** A list of edges which contains the `FiscalYear` and cursor to aid in pagination. */
  edges: Array<FiscalYearsEdge>;
  /** A list of `FiscalYear` objects. */
  nodes: Array<FiscalYear>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FiscalYear` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FiscalYear` edge in the connection. */
export type FiscalYearsEdge = {
  __typename?: 'FiscalYearsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `FiscalYear` at the end of the edge. */
  node: FiscalYear;
};

/** Methods to use when ordering `FiscalYear`. */
export enum FiscalYearsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  BudgetRevisionModeAsc = 'BUDGET_REVISION_MODE_ASC',
  BudgetRevisionModeDesc = 'BUDGET_REVISION_MODE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PreviewAsc = 'PREVIEW_ASC',
  PreviewDesc = 'PREVIEW_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ValueAsc = 'VALUE_ASC',
  ValueDesc = 'VALUE_DESC',
}

export type FutureJob = {
  __typename?: 'FutureJob';
  /** Reads a single `Account` that is related to this `FutureJob`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** Reads a single `FiscalYear` that is related to this `FutureJob`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the FutureJob. */
  id: Scalars['UUID'];
  /** The data that will be passed into the task. */
  taskData: Maybe<Scalars['JSON']>;
  /** The task name that will be executed. */
  taskName: Scalars['String'];
};

/**
 * A condition to be used against `FutureJob` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type FutureJobCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `taskName` field. */
  taskName?: InputMaybe<Scalars['String']>;
};

/** A connection to a list of `FutureJob` values. */
export type FutureJobsConnection = {
  __typename?: 'FutureJobsConnection';
  /** A list of edges which contains the `FutureJob` and cursor to aid in pagination. */
  edges: Array<FutureJobsEdge>;
  /** A list of `FutureJob` objects. */
  nodes: Array<FutureJob>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FutureJob` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `FutureJob` edge in the connection. */
export type FutureJobsEdge = {
  __typename?: 'FutureJobsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `FutureJob` at the end of the edge. */
  node: FutureJob;
};

/** Methods to use when ordering `FutureJob`. */
export enum FutureJobsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TaskNameAsc = 'TASK_NAME_ASC',
  TaskNameDesc = 'TASK_NAME_DESC',
}

export type GeneralLedger = {
  __typename?: 'GeneralLedger';
  /** Reads a single `Account` that is related to this `GeneralLedger`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `CodeCheckResult`. */
  codeCheckResults: CodeCheckResultsConnection;
  /** The Classroom Spending Report chart data for the General Ledger. Populated after generating a report from the General Ledger. */
  csrChartData: Maybe<Scalars['JSON']>;
  /** The display name for this General Ledger. */
  displayName: Scalars['String'];
  /** Optional error details if there is an unrecoverable error while processing this General Ledger. */
  errorDetails: Maybe<Scalars['String']>;
  /** Reads a single `FiscalYear` that is related to this `GeneralLedger`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Reads a single `File` that is related to this `GeneralLedger`. */
  generalLedgerFile: Maybe<File>;
  generalLedgerFileId: Maybe<Scalars['UUID']>;
  /** Reads a single `GeneralLedgersSystem` that is related to this `GeneralLedger`. */
  generalLedgersSystemByGeneralLedgersId: Maybe<GeneralLedgersSystem>;
  /** Whether or not to generate a CTED report for this General Ledger once the code check is completed. */
  generateCtedReport: Scalars['Boolean'];
  /** Whether or not to generate an IDC report for this General Ledger once the code check is completed. */
  generateIdcReport: Scalars['Boolean'];
  /** Primary key of the General Ledger. */
  id: Scalars['UUID'];
  /** Reads through a `general_ledgers_system`.'general_ledgers_id' */
  jobId: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `NormalizedRecord`. */
  normalizedRecords: NormalizedRecordsConnection;
  /** The current processing status of the General Ledger. It will update as the ledger moves through the different stages of processing. If it is "ERROR", investigate the "processing_step" and "error_details" columns for more information. */
  processingStatus: Maybe<GeneralLedgerProcessingStatus>;
  /** The current processing step of the General Ledger. It will update as the ledger moves through the different stages of processing. */
  processingStep: Maybe<GeneralLedgerProcessingStep>;
  /** The progress percentage representing how complete the current processing_step is. */
  progressPercent: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `Report`. */
  reports: ReportsConnection;
  /** The source of the General Ledger. This indicates what action a user took to result in this General Ledger. */
  source: GeneralLedgerSource;
  /** Reads and enables pagination through a set of `SpedRecord`. */
  spedRecords: SpedRecordsConnection;
  /** The current status of the General Ledger. */
  status: GeneralLedgerStatus;
  /** The time that this General Ledger was uploaded. */
  uploadedDate: Scalars['Datetime'];
  /** Whether or not to use the new salary rules introduced in the FY2024 USFR when running code checks against this General Ledger. */
  useNewSalaryRules: Scalars['Boolean'];
  /** Reads a single `User` that is related to this `GeneralLedger`. */
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']>;
};

export type GeneralLedgerCodeCheckResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CodeCheckResultCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CodeCheckResultsOrderBy>>;
};

export type GeneralLedgerNormalizedRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NormalizedRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NormalizedRecordsOrderBy>>;
};

export type GeneralLedgerReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

export type GeneralLedgerSpedRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SpedRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpedRecordsOrderBy>>;
};

/**
 * A condition to be used against `GeneralLedger` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GeneralLedgerCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `generalLedgerFileId` field. */
  generalLedgerFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `source` field. */
  source?: InputMaybe<GeneralLedgerSource>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<GeneralLedgerStatus>;
  /** Checks for equality with the object’s `uploadedDate` field. */
  uploadedDate?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum GeneralLedgerProcessingStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Pending = 'PENDING',
  StoppedEarly = 'STOPPED_EARLY',
}

export enum GeneralLedgerProcessingStep {
  CodeCheck = 'CODE_CHECK',
  Normalization = 'NORMALIZATION',
}

export enum GeneralLedgerSource {
  CodeCheck = 'CODE_CHECK',
  PreviousAfr = 'PREVIOUS_AFR',
}

export enum GeneralLedgerStatus {
  Draft = 'DRAFT',
  Final = 'FINAL',
}

/** A connection to a list of `GeneralLedger` values. */
export type GeneralLedgersConnection = {
  __typename?: 'GeneralLedgersConnection';
  /** A list of edges which contains the `GeneralLedger` and cursor to aid in pagination. */
  edges: Array<GeneralLedgersEdge>;
  /** A list of `GeneralLedger` objects. */
  nodes: Array<GeneralLedger>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GeneralLedger` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GeneralLedger` edge in the connection. */
export type GeneralLedgersEdge = {
  __typename?: 'GeneralLedgersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `GeneralLedger` at the end of the edge. */
  node: GeneralLedger;
};

/** Methods to use when ordering `GeneralLedger`. */
export enum GeneralLedgersOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  GeneralLedgerFileIdAsc = 'GENERAL_LEDGER_FILE_ID_ASC',
  GeneralLedgerFileIdDesc = 'GENERAL_LEDGER_FILE_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SourceAsc = 'SOURCE_ASC',
  SourceDesc = 'SOURCE_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  UploadedDateAsc = 'UPLOADED_DATE_ASC',
  UploadedDateDesc = 'UPLOADED_DATE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

export type GeneralLedgersSystem = {
  __typename?: 'GeneralLedgersSystem';
  /** Reads a single `GeneralLedger` that is related to this `GeneralLedgersSystem`. */
  generalLedgers: Maybe<GeneralLedger>;
  generalLedgersId: Scalars['UUID'];
  /** Reads a single `JobResult` that is related to this `GeneralLedgersSystem`. */
  job: Maybe<JobResult>;
  jobId: Maybe<Scalars['UUID']>;
  /** The current processing status of the General Ledger. It will update as the ledger moves through the different stages of processing. If it is "ERROR", investigate the "processing_step" and "error_details" columns for more information. */
  processingStatus: GeneralLedgerProcessingStatus;
  /** The current processing step of the General Ledger. It will update as the ledger moves through the different stages of processing. */
  processingStep: GeneralLedgerProcessingStep;
  /** The progress percentage representing how complete the current processing_step is. */
  progressPercent: Maybe<Scalars['Int']>;
};

/**
 * A condition to be used against `GeneralLedgersSystem` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type GeneralLedgersSystemCondition = {
  /** Checks for equality with the object’s `generalLedgersId` field. */
  generalLedgersId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `jobId` field. */
  jobId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `processingStatus` field. */
  processingStatus?: InputMaybe<GeneralLedgerProcessingStatus>;
  /** Checks for equality with the object’s `processingStep` field. */
  processingStep?: InputMaybe<GeneralLedgerProcessingStep>;
};

/** A connection to a list of `GeneralLedgersSystem` values. */
export type GeneralLedgersSystemsConnection = {
  __typename?: 'GeneralLedgersSystemsConnection';
  /** A list of edges which contains the `GeneralLedgersSystem` and cursor to aid in pagination. */
  edges: Array<GeneralLedgersSystemsEdge>;
  /** A list of `GeneralLedgersSystem` objects. */
  nodes: Array<GeneralLedgersSystem>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GeneralLedgersSystem` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `GeneralLedgersSystem` edge in the connection. */
export type GeneralLedgersSystemsEdge = {
  __typename?: 'GeneralLedgersSystemsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `GeneralLedgersSystem` at the end of the edge. */
  node: GeneralLedgersSystem;
};

/** Methods to use when ordering `GeneralLedgersSystem`. */
export enum GeneralLedgersSystemsOrderBy {
  GeneralLedgersIdAsc = 'GENERAL_LEDGERS_ID_ASC',
  GeneralLedgersIdDesc = 'GENERAL_LEDGERS_ID_DESC',
  JobIdAsc = 'JOB_ID_ASC',
  JobIdDesc = 'JOB_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProcessingStatusAsc = 'PROCESSING_STATUS_ASC',
  ProcessingStatusDesc = 'PROCESSING_STATUS_DESC',
  ProcessingStepAsc = 'PROCESSING_STEP_ASC',
  ProcessingStepDesc = 'PROCESSING_STEP_DESC',
}

/** All input for the `generateBudgetRevisionReport` mutation. */
export type GenerateBudgetRevisionReportInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fiscalYearId: Scalars['UUID'];
};

/** The output of our `generateBudgetRevisionReport` mutation. */
export type GenerateBudgetRevisionReportPayload = {
  __typename?: 'GenerateBudgetRevisionReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `generateCsrReport` mutation. */
export type GenerateCsrReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ledgerId: Scalars['UUID'];
};

/** The output of our `generateCsrReport` mutation. */
export type GenerateCsrReportPayload = {
  __typename?: 'GenerateCsrReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `generateCtedReport` mutation. */
export type GenerateCtedReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ledgerId: Scalars['UUID'];
};

/** The output of our `generateCtedReport` mutation. */
export type GenerateCtedReportPayload = {
  __typename?: 'GenerateCtedReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `generateIndirectCostReport` mutation. */
export type GenerateIndirectCostReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ledgerId: Scalars['UUID'];
};

/** The output of our `generateIndirectCostReport` mutation. */
export type GenerateIndirectCostReportPayload = {
  __typename?: 'GenerateIndirectCostReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

export type HelpTicket = {
  __typename?: 'HelpTicket';
  /** Reads a single `Account` that is related to this `HelpTicket`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** The description of the problem the user is requesting help with. This value is user provided. */
  description: Scalars['String'];
  /** Primary key of the Help Ticket. */
  id: Scalars['UUID'];
  /** Whether or not this ticket has been resolved. */
  resolved: Scalars['Boolean'];
  /** The subject selected by the user. If "Other", user should have provided a custom subject. */
  subject: HelpTicketSubject;
  /** Reads a single `User` that is related to this `HelpTicket`. */
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']>;
  /** A custom subject provided by the user. Should only happen if the user selects "Other" for the system-provided subject. */
  userProvidedSubject: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `HelpTicket` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type HelpTicketCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<HelpTicketSubject>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum HelpTicketSubject {
  Other = 'OTHER',
  WhatDoYouNeedHelpWith = 'WHAT_DO_YOU_NEED_HELP_WITH_',
}

/** A connection to a list of `HelpTicket` values. */
export type HelpTicketsConnection = {
  __typename?: 'HelpTicketsConnection';
  /** A list of edges which contains the `HelpTicket` and cursor to aid in pagination. */
  edges: Array<HelpTicketsEdge>;
  /** A list of `HelpTicket` objects. */
  nodes: Array<HelpTicket>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HelpTicket` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `HelpTicket` edge in the connection. */
export type HelpTicketsEdge = {
  __typename?: 'HelpTicketsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `HelpTicket` at the end of the edge. */
  node: HelpTicket;
};

/** Methods to use when ordering `HelpTicket`. */
export enum HelpTicketsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  SubjectAsc = 'SUBJECT_ASC',
  SubjectDesc = 'SUBJECT_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

/** All input for the `importSchoolData` mutation. */
export type ImportSchoolDataInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fiscalYearId: Scalars['String'];
};

/** The output of our `importSchoolData` mutation. */
export type ImportSchoolDataPayload = {
  __typename?: 'ImportSchoolDataPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type InviteLink = {
  __typename?: 'InviteLink';
  /** Reads a single `Account` that is related to this `InviteLink`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** Primary key of the Invite Link. */
  id: Scalars['UUID'];
  /** Reads a single `Role` that is related to this `InviteLink`. */
  role: Maybe<Role>;
  roleId: Maybe<Scalars['UUID']>;
  /** The current state of the invite link. */
  state: InviteState;
  /** Reads a single `User` that is related to this `InviteLink`. */
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']>;
};

/**
 * A condition to be used against `InviteLink` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type InviteLinkCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `state` field. */
  state?: InputMaybe<InviteState>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `InviteLink` values. */
export type InviteLinksConnection = {
  __typename?: 'InviteLinksConnection';
  /** A list of edges which contains the `InviteLink` and cursor to aid in pagination. */
  edges: Array<InviteLinksEdge>;
  /** A list of `InviteLink` objects. */
  nodes: Array<InviteLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `InviteLink` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `InviteLink` edge in the connection. */
export type InviteLinksEdge = {
  __typename?: 'InviteLinksEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `InviteLink` at the end of the edge. */
  node: InviteLink;
};

/** Methods to use when ordering `InviteLink`. */
export enum InviteLinksOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleIdAsc = 'ROLE_ID_ASC',
  RoleIdDesc = 'ROLE_ID_DESC',
  StateAsc = 'STATE_ASC',
  StateDesc = 'STATE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

export enum InviteState {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED',
}

/** All input for the `inviteToAccount` mutation. */
export type InviteToAccountInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  roleId: Scalars['UUID'];
};

/** The output of our `inviteToAccount` mutation. */
export type InviteToAccountPayload = {
  __typename?: 'InviteToAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

export type JobResult = {
  __typename?: 'JobResult';
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `GeneralLedgersSystem`. */
  generalLedgersSystemsByJobId: GeneralLedgersSystemsConnection;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Report`. */
  reportsByJobId: ReportsConnection;
  result: Maybe<Scalars['JSON']>;
  status: Scalars['String'];
  taskIdentifier: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `JobResult`. */
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']>;
};

export type JobResultGeneralLedgersSystemsByJobIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GeneralLedgersSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeneralLedgersSystemsOrderBy>>;
};

export type JobResultReportsByJobIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/**
 * A condition to be used against `JobResult` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type JobResultCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export type JobResultSubscriptionPayload = {
  __typename?: 'JobResultSubscriptionPayload';
  event: Maybe<Scalars['String']>;
  jobResult: Maybe<JobResult>;
};

/** A connection to a list of `JobResult` values. */
export type JobResultsConnection = {
  __typename?: 'JobResultsConnection';
  /** A list of edges which contains the `JobResult` and cursor to aid in pagination. */
  edges: Array<JobResultsEdge>;
  /** A list of `JobResult` objects. */
  nodes: Array<JobResult>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `JobResult` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `JobResult` edge in the connection. */
export type JobResultsEdge = {
  __typename?: 'JobResultsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `JobResult` at the end of the edge. */
  node: JobResult;
};

/** Methods to use when ordering `JobResult`. */
export enum JobResultsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

/** All input for the `kickMember` mutation. */
export type KickMemberInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  membershipId: Scalars['UUID'];
};

/** The output of our `kickMember` mutation. */
export type KickMemberPayload = {
  __typename?: 'KickMemberPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

/** All input for the `leaveAccount` mutation. */
export type LeaveAccountInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `leaveAccount` mutation. */
export type LeaveAccountPayload = {
  __typename?: 'LeaveAccountPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type LoginInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginPayload = {
  __typename?: 'LoginPayload';
  user: User;
};

export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /**
   * This field provides a URL that the client should redirect to immediately after the logout mutation completes.
   * The redirect will perform necessary logic to log the user out of their identity provider as well (such as Auth0).
   */
  logoutUrl: Maybe<Scalars['String']>;
  /** This field indicates whether or not the user was successfully logged out of the application. */
  success: Maybe<Scalars['Boolean']>;
};

/** All input for the `makeEmailPrimary` mutation. */
export type MakeEmailPrimaryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailId: Scalars['UUID'];
};

/** The output of our `makeEmailPrimary` mutation. */
export type MakeEmailPrimaryPayload = {
  __typename?: 'MakeEmailPrimaryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `User` that is related to this `UserEmail`. */
  user: Maybe<User>;
  userEmail: Maybe<UserEmail>;
  /** An edge for our `UserEmail`. May be used by Relay 1. */
  userEmailEdge: Maybe<UserEmailsEdge>;
};

/** The output of our `makeEmailPrimary` mutation. */
export type MakeEmailPrimaryPayloadUserEmailEdgeArgs = {
  orderBy?: InputMaybe<Array<UserEmailsOrderBy>>;
};

/** All input for the `markFileUploaded` mutation. */
export type MarkFileUploadedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fileId: Scalars['UUID'];
};

/** The output of our `markFileUploaded` mutation. */
export type MarkFileUploadedPayload = {
  __typename?: 'MarkFileUploadedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite: Maybe<AcceptInvitePayload>;
  /** Method for accepting the terms & conditions and privacy policy. */
  acceptTerms: Maybe<AcceptTermsPayload>;
  /** Method for acknowledging a notification for the logged in user. */
  acknowledgeNotification: Maybe<AcknowledgeNotificationPayload>;
  /** Build a signed url for downloading a specific file. */
  buildFileDownloadUrl: Maybe<SignedUrlForFileDownload>;
  /** Build a signed url for downloading a report file. */
  buildReportDownloadUrl: Maybe<SignedUrlForReportDownload>;
  /**
   * Issues a short-lived signed URL for the scrape runner to upload one
   * downloaded report to.
   */
  buildScrapeUploadUrl: Maybe<ScrapeUploadTarget>;
  /** Build a signed url for uploading a file to an account. */
  buildSignedUrlForAccount: Maybe<SignedUrlForUpload>;
  /** Build a signed url for uploading a file to a ledger. */
  buildSignedUrlForLedger: Maybe<SignedUrlForUpload>;
  changeMemberRole: Maybe<ChangeMemberRolePayload>;
  /** Method for changing the users email address. This will kick off a job with the same ID as the email UUID passed into the function, and changes will be propagated to identity provider. Returns true if job was successfully queued, otherwise false. */
  changeUserEmail: Maybe<ChangeUserEmailPayload>;
  /** Closes out a run and queues ingestion of everything it uploaded. */
  completeScrapeAttempt: Maybe<CompleteScrapeAttemptPayload>;
  /** If you're certain you want to delete your account, use `requestAccountDeletion` to request an account deletion token, and then supply the token through this mutation to complete account deletion. */
  confirmAccountDeletion: Maybe<ConfirmAccountDeletionPayload>;
  createAccount: Maybe<CreateAccountPayload>;
  /** Method for creating the shell of a general ledger in the system. All files will need to be uploaded separately using build_signed_url and update_file_status. */
  createGeneralLedger: Maybe<CreateGeneralLedgerPayload>;
  /** Delete a district contact by ID. */
  deleteDistrictContact: Maybe<DeleteDistrictContactPayload>;
  /** Delete a school by ID. */
  deleteSchool: Maybe<DeleteSchoolPayload>;
  /** Method for extracting budget data for all files in a given fiscal year. If no account ID is given, it will run for all accounts. Otherwise, it will only run for the provided account. */
  extractBudgetDataForYear: Maybe<ExtractBudgetDataForYearPayload>;
  /** Method for generating a budget revision report for a given account and fiscal year. Requires adopted budget, previous year AFR, previous year budget, and ADM data. */
  generateBudgetRevisionReport: Maybe<GenerateBudgetRevisionReportPayload>;
  /** Method for generating a Classroom Spending Report from a given general ledger, independently of the AFR. This operation can only be performed against FINAL ledgers in the COMPLETE status. */
  generateCsrReport: Maybe<GenerateCsrReportPayload>;
  /** Method for generating a CTED member district workbook from a given general ledger. This operation can only be performed against FINAL ledgers in the COMPLETE status. */
  generateCtedReport: Maybe<GenerateCtedReportPayload>;
  /** Method for generating an indirect cost report (IDC) from a given general ledger. This operation can only be performed against FINAL ledgers in the COMPLETE status. */
  generateIndirectCostReport: Maybe<GenerateIndirectCostReportPayload>;
  /** Method for triggering ingest of school data. This will kick off a job with a random UUID. Returns true if job was successfully queued, otherwise false. */
  importSchoolData: Maybe<ImportSchoolDataPayload>;
  /** Method for inviting a user to an account by email. This method performs validation and then enters a job in a queue to perform the work required to invite a user and create a new user if necessary. Returns the job ID if the job was successfully created. */
  inviteToAccount: Maybe<InviteToAccountPayload>;
  kickMember: Maybe<KickMemberPayload>;
  leaveAccount: Maybe<LeaveAccountPayload>;
  /** Use this mutation to log in to your account; this login uses sessions so you do not need to take further action. */
  login: Maybe<LoginPayload>;
  /** Use this mutation to logout from your account. Don't forget to clear the client state! */
  logout: Maybe<LogoutPayload>;
  /** Your primary email is where we'll notify of account events; other emails may be used for discovery or login. Use this when you're changing your email address. */
  makeEmailPrimary: Maybe<MakeEmailPrimaryPayload>;
  /** Method for marking a file as uploaded. All files associated with a general ledger must be marked as uploaded before processing can begin. */
  markFileUploaded: Maybe<MarkFileUploadedPayload>;
  rejectInvite: Maybe<RejectInvitePayload>;
  /** Begin the account deletion flow by requesting the confirmation email */
  requestAccountDeletion: Maybe<RequestAccountDeletionPayload>;
  revokeInvite: Maybe<RevokeInvitePayload>;
  singleCodeCheck: Maybe<Array<SingleCodeCheckResult>>;
  /** Method for starting a worker job based on the data within the future job. The future job ID will be placed in the task data. */
  startFutureJob: Maybe<StartFutureJobPayload>;
  /** Method for starting to generate reports for a given general ledger. */
  startGeneratingReport: Maybe<StartGeneratingReportPayload>;
  /** Method for starting to process a given general ledger. The process begins with a normalization step, and if it passes that, it will begin performing a code check against the ledger. */
  startProcessingLedger: Maybe<StartProcessingLedgerPayload>;
  /** Method for starting to process a previous year's AFR file. The process begins with a normalization step to extract the general ledger information, then uses that data to calculate Classroom Spending Report chart information. */
  startProcessingPreviousAfr: Maybe<StartProcessingPreviousAfrPayload>;
  /**
   * Authorizes a scrape run for the current system admin and mints the
   * token its local runner authenticates with.
   */
  startScrapeRun: Maybe<StartScrapeRunResult>;
  /** Method for submitting a help ticket as a user of the system. */
  submitHelpTicket: Maybe<SubmitHelpTicketPayload>;
  /** Method for updating an accounts information. Returns the updated account information. */
  updateAccount: Maybe<UpdateAccountPayload>;
  /** Method for updating the expiration on an account feature record. */
  updateAccountFeatureExpiration: Maybe<UpdateAccountFeatureExpirationPayload>;
  /** Method for updating an accounts year-based settings. Returns the updated account information. */
  updateAccountSettings: Maybe<UpdateAccountSettingsPayload>;
  /** Method for updating a users information. Returns true if successful, otherwise false */
  updateUser: Maybe<UpdateUserPayload>;
  /** Upsert a district contact. Contact ID is required in all cases. */
  upsertDistrictContact: Maybe<UpsertDistrictContactPayload>;
  /** Method for upserting future job data. This will update the existing job if it exists, or create a new one if it doesnt. Criteria for existing is based on account ID, fiscal year, and task name. */
  upsertFutureJob: Maybe<UpsertFutureJobPayload>;
  /** Upsert a school. Entity ID is required in all cases. */
  upsertSchool: Maybe<UpsertSchoolPayload>;
  /** Once you have received a verification token for your email, you may call this mutation with that token to make your email verified. */
  verifyEmail: Maybe<VerifyEmailPayload>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcceptInviteArgs = {
  input: AcceptInviteInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcceptTermsArgs = {
  input: AcceptTermsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcknowledgeNotificationArgs = {
  input: AcknowledgeNotificationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationBuildFileDownloadUrlArgs = {
  fileId: Scalars['UUID'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationBuildReportDownloadUrlArgs = {
  reportId: Scalars['UUID'];
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationBuildScrapeUploadUrlArgs = {
  input: BuildScrapeUploadUrlInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationBuildSignedUrlForAccountArgs = {
  input: BuildSignedUrlForAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationBuildSignedUrlForLedgerArgs = {
  input: BuildSignedUrlForLedgerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeMemberRoleArgs = {
  input: ChangeMemberRoleInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationChangeUserEmailArgs = {
  input: ChangeUserEmailInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCompleteScrapeAttemptArgs = {
  input: CompleteScrapeAttemptInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationConfirmAccountDeletionArgs = {
  input: ConfirmAccountDeletionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGeneralLedgerArgs = {
  input: CreateGeneralLedgerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteDistrictContactArgs = {
  input: DeleteDistrictContactInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteSchoolArgs = {
  input: DeleteSchoolInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationExtractBudgetDataForYearArgs = {
  input: ExtractBudgetDataForYearInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateBudgetRevisionReportArgs = {
  input: GenerateBudgetRevisionReportInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateCsrReportArgs = {
  input: GenerateCsrReportInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateCtedReportArgs = {
  input: GenerateCtedReportInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateIndirectCostReportArgs = {
  input: GenerateIndirectCostReportInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationImportSchoolDataArgs = {
  input: ImportSchoolDataInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationInviteToAccountArgs = {
  input: InviteToAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationKickMemberArgs = {
  input: KickMemberInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationLeaveAccountArgs = {
  input: LeaveAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationLoginArgs = {
  input: LoginInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationMakeEmailPrimaryArgs = {
  input: MakeEmailPrimaryInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkFileUploadedArgs = {
  input: MarkFileUploadedInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRejectInviteArgs = {
  input: RejectInviteInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRequestAccountDeletionArgs = {
  input: RequestAccountDeletionInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationRevokeInviteArgs = {
  input: RevokeInviteInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSingleCodeCheckArgs = {
  input: SingleCodeCheckInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartFutureJobArgs = {
  input: StartFutureJobInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartGeneratingReportArgs = {
  input: StartGeneratingReportInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartProcessingLedgerArgs = {
  input: StartProcessingLedgerInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationStartProcessingPreviousAfrArgs = {
  input: StartProcessingPreviousAfrInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationSubmitHelpTicketArgs = {
  input: SubmitHelpTicketInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountArgs = {
  input: UpdateAccountInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountFeatureExpirationArgs = {
  input: UpdateAccountFeatureExpirationInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAccountSettingsArgs = {
  input: UpdateAccountSettingsInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertDistrictContactArgs = {
  input: UpsertDistrictContactInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertFutureJobArgs = {
  input: UpsertFutureJobInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertSchoolArgs = {
  input: UpsertSchoolInput;
};

/** The root mutation type which contains root level fields which mutate data. */
export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};

export type NormalizedRecord = {
  __typename?: 'NormalizedRecord';
  /** The cost or revenue amount in the currency's smallest unit */
  amount: Scalars['BigInt'];
  /** The Description */
  description: Scalars['String'];
  /** The Function Code */
  functionCode: Scalars['String'];
  /** The Fund Code */
  fundCode: Scalars['String'];
  /** Reads a single `GeneralLedger` that is related to this `NormalizedRecord`. */
  generalLedger: Maybe<GeneralLedger>;
  generalLedgerId: Maybe<Scalars['UUID']>;
  /** Primary key of the NormalizedRecord. */
  id: Scalars['UUID'];
  /** The Object Code */
  objectCode: Scalars['String'];
  /** The original account code without any modifications. */
  originalAccountCode: Scalars['String'];
  /** The Program Code */
  programCode: Scalars['String'];
  /** The source line of the original file where this result was found */
  sourceLine: Scalars['Int'];
  /** The Unit Code */
  unitCode: Scalars['String'];
};

/**
 * A condition to be used against `NormalizedRecord` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NormalizedRecordCondition = {
  /** Checks for equality with the object’s `generalLedgerId` field. */
  generalLedgerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `NormalizedRecord` values. */
export type NormalizedRecordsConnection = {
  __typename?: 'NormalizedRecordsConnection';
  /** A list of edges which contains the `NormalizedRecord` and cursor to aid in pagination. */
  edges: Array<NormalizedRecordsEdge>;
  /** A list of `NormalizedRecord` objects. */
  nodes: Array<NormalizedRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NormalizedRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NormalizedRecord` edge in the connection. */
export type NormalizedRecordsEdge = {
  __typename?: 'NormalizedRecordsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `NormalizedRecord` at the end of the edge. */
  node: NormalizedRecord;
};

/** Methods to use when ordering `NormalizedRecord`. */
export enum NormalizedRecordsOrderBy {
  GeneralLedgerIdAsc = 'GENERAL_LEDGER_ID_ASC',
  GeneralLedgerIdDesc = 'GENERAL_LEDGER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type Notification = {
  __typename?: 'Notification';
  /** Reads a single `Account` that is related to this `Notification`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** Whether or not the user has acknowledged this notification. If acknowledged, it should stop trying to get the user's attention. */
  acknowledged: Maybe<Scalars['Boolean']>;
  /** The time that this Notification was created. */
  createdAt: Scalars['Datetime'];
  /** Primary key of the Notification. */
  id: Scalars['UUID'];
  /** The information that this notification is meant to convey to the user. */
  message: Scalars['String'];
  /** Reads a single `NotificationsOwner` that is related to this `Notification`. */
  notificationsOwnerByNotificationsId: Maybe<NotificationsOwner>;
  /** Reads a single `User` that is related to this `Notification`. */
  user: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `Notification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Notification` values. */
export type NotificationsConnection = {
  __typename?: 'NotificationsConnection';
  /** A list of edges which contains the `Notification` and cursor to aid in pagination. */
  edges: Array<NotificationsEdge>;
  /** A list of `Notification` objects. */
  nodes: Array<Notification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Notification` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Notification` edge in the connection. */
export type NotificationsEdge = {
  __typename?: 'NotificationsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Notification` at the end of the edge. */
  node: Notification;
};

/** Methods to use when ordering `Notification`. */
export enum NotificationsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

export type NotificationsOwner = {
  __typename?: 'NotificationsOwner';
  /** Whether or not the user has acknowledged this notification. If acknowledged, it should stop trying to get the user's attention. */
  acknowledged: Scalars['Boolean'];
  /** Reads a single `Notification` that is related to this `NotificationsOwner`. */
  notifications: Maybe<Notification>;
  notificationsId: Scalars['UUID'];
};

/**
 * A condition to be used against `NotificationsOwner` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type NotificationsOwnerCondition = {
  /** Checks for equality with the object’s `acknowledged` field. */
  acknowledged?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `notificationsId` field. */
  notificationsId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `NotificationsOwner` values. */
export type NotificationsOwnersConnection = {
  __typename?: 'NotificationsOwnersConnection';
  /** A list of edges which contains the `NotificationsOwner` and cursor to aid in pagination. */
  edges: Array<NotificationsOwnersEdge>;
  /** A list of `NotificationsOwner` objects. */
  nodes: Array<NotificationsOwner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NotificationsOwner` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `NotificationsOwner` edge in the connection. */
export type NotificationsOwnersEdge = {
  __typename?: 'NotificationsOwnersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `NotificationsOwner` at the end of the edge. */
  node: NotificationsOwner;
};

/** Methods to use when ordering `NotificationsOwner`. */
export enum NotificationsOwnersOrderBy {
  AcknowledgedAsc = 'ACKNOWLEDGED_ASC',
  AcknowledgedDesc = 'ACKNOWLEDGED_DESC',
  Natural = 'NATURAL',
  NotificationsIdAsc = 'NOTIFICATIONS_ID_ASC',
  NotificationsIdDesc = 'NOTIFICATIONS_ID_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['Cursor']>;
};

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  account: Maybe<Account>;
  accountFeatureByAccountIdAndFeatureId: Maybe<AccountFeature>;
  /** Reads and enables pagination through a set of `AccountFeature`. */
  accountFeatures: Maybe<AccountFeaturesConnection>;
  accountFiscalYearByAccountIdAndFiscalYearId: Maybe<AccountFiscalYear>;
  /** Reads and enables pagination through a set of `AccountFiscalYear`. */
  accountFiscalYears: Maybe<AccountFiscalYearsConnection>;
  /** A custom query for retrieving user information within a given account. This will include pending invite links as well. */
  accountMembers: Maybe<AccountMembersConnection>;
  accountMembership: Maybe<AccountMembership>;
  accountMembershipByAccountIdAndUserId: Maybe<AccountMembership>;
  /** Reads and enables pagination through a set of `AccountMembership`. */
  accountMemberships: Maybe<AccountMembershipsConnection>;
  /** Reads and enables pagination through a set of `Account`. */
  accounts: Maybe<AccountsConnection>;
  accountsOwner: Maybe<AccountsOwner>;
  /** Reads and enables pagination through a set of `AccountsOwner`. */
  accountsOwners: Maybe<AccountsOwnersConnection>;
  accountsSystem: Maybe<AccountsSystem>;
  /** Reads and enables pagination through a set of `AccountsSystem`. */
  accountsSystems: Maybe<AccountsSystemsConnection>;
  aiDocument: Maybe<AiDocument>;
  aiDocumentEmbedding: Maybe<AiDocumentEmbedding>;
  /** Reads and enables pagination through a set of `AiDocumentEmbedding`. */
  aiDocumentEmbeddings: Maybe<AiDocumentEmbeddingsConnection>;
  aiDocumentSource: Maybe<AiDocumentSource>;
  /** Reads and enables pagination through a set of `AiDocumentSource`. */
  aiDocumentSources: Maybe<AiDocumentSourcesConnection>;
  /** Reads and enables pagination through a set of `AiDocument`. */
  aiDocuments: Maybe<AiDocumentsConnection>;
  aiUsageConfig: Maybe<AiUsageConfig>;
  aiUsageConfigByAccountId: Maybe<AiUsageConfig>;
  /** Reads and enables pagination through a set of `AiUsageConfig`. */
  aiUsageConfigs: Maybe<AiUsageConfigsConnection>;
  aiUsageLog: Maybe<AiUsageLog>;
  /** Reads and enables pagination through a set of `AiUsageLog`. */
  aiUsageLogs: Maybe<AiUsageLogsConnection>;
  codeCheckCustomization: Maybe<CodeCheckCustomization>;
  /** Reads and enables pagination through a set of `CodeCheckCustomization`. */
  codeCheckCustomizations: Maybe<CodeCheckCustomizationsConnection>;
  /** Reads and enables pagination through a set of `CodeCheckResult`. */
  codeCheckResults: Maybe<CodeCheckResultsConnection>;
  /** The currently logged in user (or null if not logged in). */
  currentUser: Maybe<User>;
  districtCoaSegment: Maybe<DistrictCoaSegment>;
  districtCoaSegmentByAccountIdAndFiscalYearIdAndSegmentName: Maybe<DistrictCoaSegment>;
  /** Reads and enables pagination through a set of `DistrictCoaSegment`. */
  districtCoaSegments: Maybe<DistrictCoaSegmentsConnection>;
  districtCodeOption: Maybe<DistrictCodeOption>;
  /** Reads and enables pagination through a set of `DistrictCodeOption`. */
  districtCodeOptions: Maybe<DistrictCodeOptionsConnection>;
  districtContact: Maybe<DistrictContact>;
  /** Reads and enables pagination through a set of `DistrictContact`. */
  districtContacts: Maybe<DistrictContactsConnection>;
  feature: Maybe<Feature>;
  /** Reads and enables pagination through a set of `Feature`. */
  features: Maybe<FeaturesConnection>;
  file: Maybe<File>;
  fileTemplateVersion: Maybe<FileTemplateVersion>;
  fileTemplateVersionByAfrVersionAndSlVersionAndSystemVersionAndStateIdAndFiscalYearId: Maybe<FileTemplateVersion>;
  /** Reads and enables pagination through a set of `FileTemplateVersion`. */
  fileTemplateVersions: Maybe<FileTemplateVersionsConnection>;
  /** Reads and enables pagination through a set of `File`. */
  files: Maybe<FilesConnection>;
  filesSystem: Maybe<FilesSystem>;
  /** Reads and enables pagination through a set of `FilesSystem`. */
  filesSystems: Maybe<FilesSystemsConnection>;
  fiscalYear: Maybe<FiscalYear>;
  /** Reads and enables pagination through a set of `FiscalYear`. */
  fiscalYears: Maybe<FiscalYearsConnection>;
  futureJob: Maybe<FutureJob>;
  /** Reads and enables pagination through a set of `FutureJob`. */
  futureJobs: Maybe<FutureJobsConnection>;
  generalLedger: Maybe<GeneralLedger>;
  /** Reads and enables pagination through a set of `GeneralLedger`. */
  generalLedgers: Maybe<GeneralLedgersConnection>;
  generalLedgersSystem: Maybe<GeneralLedgersSystem>;
  /** Reads and enables pagination through a set of `GeneralLedgersSystem`. */
  generalLedgersSystems: Maybe<GeneralLedgersSystemsConnection>;
  getMyScopesForAccount: Maybe<Array<Maybe<Scalars['String']>>>;
  helpTicket: Maybe<HelpTicket>;
  /** Reads and enables pagination through a set of `HelpTicket`. */
  helpTickets: Maybe<HelpTicketsConnection>;
  inviteLink: Maybe<InviteLink>;
  /** Reads and enables pagination through a set of `InviteLink`. */
  inviteLinks: Maybe<InviteLinksConnection>;
  jobResult: Maybe<JobResult>;
  /** Reads and enables pagination through a set of `JobResult`. */
  jobResults: Maybe<JobResultsConnection>;
  normalizedRecord: Maybe<NormalizedRecord>;
  /** Reads and enables pagination through a set of `NormalizedRecord`. */
  normalizedRecords: Maybe<NormalizedRecordsConnection>;
  notification: Maybe<Notification>;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: Maybe<NotificationsConnection>;
  notificationsOwner: Maybe<NotificationsOwner>;
  /** Reads and enables pagination through a set of `NotificationsOwner`. */
  notificationsOwners: Maybe<NotificationsOwnersConnection>;
  /** A custom query for retrieving the most recent DRAFT and FINAL general ledgers for a given fiscal year. */
  recentGeneralLedgers: Maybe<RecentGeneralLedgersConnection>;
  report: Maybe<Report>;
  /** Reads and enables pagination through a set of `Report`. */
  reports: Maybe<ReportsConnection>;
  role: Maybe<Role>;
  roleScope: Maybe<RoleScope>;
  /** Reads and enables pagination through a set of `RoleScope`. */
  roleScopes: Maybe<RoleScopesConnection>;
  /** Reads and enables pagination through a set of `Role`. */
  roles: Maybe<RolesConnection>;
  school: Maybe<School>;
  /** Reads and enables pagination through a set of `School`. */
  schools: Maybe<SchoolsConnection>;
  scope: Maybe<Scope>;
  /** Reads and enables pagination through a set of `Scope`. */
  scopes: Maybe<ScopesConnection>;
  /** What the runner should scrape. */
  scrapeAttemptWork: Maybe<ScrapeAttemptWork>;
  spedRecord: Maybe<SpedRecord>;
  /** Reads and enables pagination through a set of `SpedRecord`. */
  spedRecords: Maybe<SpedRecordsConnection>;
  state: Maybe<State>;
  /** Reads and enables pagination through a set of `State`. */
  states: Maybe<StatesConnection>;
  user: Maybe<User>;
  userAuthentication: Maybe<UserAuthentication>;
  userByUsername: Maybe<User>;
  userEmail: Maybe<UserEmail>;
  usersOwner: Maybe<UsersOwner>;
  /** Reads and enables pagination through a set of `UsersOwner`. */
  usersOwners: Maybe<UsersOwnersConnection>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountFeatureByAccountIdAndFeatureIdArgs = {
  accountId: Scalars['UUID'];
  featureId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountFeaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFeatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFeaturesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountFiscalYearByAccountIdAndFiscalYearIdArgs = {
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountFiscalYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountFiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountMembersArgs = {
  accountId: Scalars['UUID'];
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountMembershipArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountMembershipByAccountIdAndUserIdArgs = {
  accountId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountMembershipCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountMembershipsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountsOwnerArgs = {
  accountsId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountsOwnersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountsOwnerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOwnersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountsSystemArgs = {
  accountsId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAccountsSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountsSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsSystemsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAiDocumentArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAiDocumentEmbeddingArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAiDocumentEmbeddingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentEmbeddingCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentEmbeddingsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAiDocumentSourceArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAiDocumentSourcesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentSourceCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentSourcesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAiDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiDocumentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiDocumentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAiUsageConfigArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAiUsageConfigByAccountIdArgs = {
  accountId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAiUsageConfigsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiUsageConfigCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiUsageConfigsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryAiUsageLogArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryAiUsageLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AiUsageLogCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AiUsageLogsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCodeCheckCustomizationArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryCodeCheckCustomizationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CodeCheckCustomizationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CodeCheckCustomizationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryCodeCheckResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CodeCheckResultCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CodeCheckResultsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDistrictCoaSegmentArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDistrictCoaSegmentByAccountIdAndFiscalYearIdAndSegmentNameArgs =
  {
    accountId: Scalars['UUID'];
    fiscalYearId: Scalars['UUID'];
    segmentName: Scalars['String'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryDistrictCoaSegmentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictCoaSegmentCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictCoaSegmentsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDistrictCodeOptionArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDistrictCodeOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictCodeOptionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictCodeOptionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryDistrictContactArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryDistrictContactsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<DistrictContactCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DistrictContactsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFeatureArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFeaturesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FeatureCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FeaturesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFileArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileTemplateVersionArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFileTemplateVersionByAfrVersionAndSlVersionAndSystemVersionAndStateIdAndFiscalYearIdArgs =
  {
    afrVersion: Scalars['String'];
    fiscalYearId: Scalars['UUID'];
    slVersion: Scalars['String'];
    stateId: Scalars['UUID'];
    systemVersion: Scalars['Int'];
  };

/** The root query type which gives access points into the data universe. */
export type QueryFileTemplateVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FileTemplateVersionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileTemplateVersionsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FileCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFilesSystemArgs = {
  filesId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFilesSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FilesSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesSystemsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFiscalYearArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFiscalYearsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FiscalYearCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FiscalYearsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryFutureJobArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryFutureJobsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FutureJobCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FutureJobsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGeneralLedgerArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryGeneralLedgersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GeneralLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeneralLedgersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGeneralLedgersSystemArgs = {
  generalLedgersId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryGeneralLedgersSystemsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GeneralLedgersSystemCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeneralLedgersSystemsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryGetMyScopesForAccountArgs = {
  accountId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryHelpTicketArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryHelpTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HelpTicketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HelpTicketsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryInviteLinkArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryInviteLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InviteLinkCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InviteLinksOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryJobResultArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryJobResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<JobResultCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobResultsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryNormalizedRecordArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryNormalizedRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NormalizedRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NormalizedRecordsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryNotificationArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryNotificationsOwnerArgs = {
  notificationsId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryNotificationsOwnersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationsOwnerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOwnersOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryRecentGeneralLedgersArgs = {
  accountId: Scalars['UUID'];
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  fiscalYearId: Scalars['UUID'];
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** The root query type which gives access points into the data universe. */
export type QueryReportArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryRoleArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryRoleScopeArgs = {
  roleId: Scalars['UUID'];
  scopeId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryRoleScopesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleScopeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryRolesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QuerySchoolArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySchoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SchoolCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SchoolsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryScopeArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryScopesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ScopeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ScopesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryScrapeAttemptWorkArgs = {
  runToken: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpedRecordArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QuerySpedRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<SpedRecordCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<SpedRecordsOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryStateArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryStatesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<StateCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<StatesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserAuthenticationArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserByUsernameArgs = {
  username: Scalars['String'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUserEmailArgs = {
  id: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUsersOwnerArgs = {
  usersId: Scalars['UUID'];
};

/** The root query type which gives access points into the data universe. */
export type QueryUsersOwnersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UsersOwnerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOwnersOrderBy>>;
};

/** A `RecentGeneralLedgersRecord` edge in the connection. */
export type RecentGeneralLedgerEdge = {
  __typename?: 'RecentGeneralLedgerEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `RecentGeneralLedgersRecord` at the end of the edge. */
  node: RecentGeneralLedgersRecord;
};

/** A connection to a list of `RecentGeneralLedgersRecord` values. */
export type RecentGeneralLedgersConnection = {
  __typename?: 'RecentGeneralLedgersConnection';
  /** A list of edges which contains the `RecentGeneralLedgersRecord` and cursor to aid in pagination. */
  edges: Array<RecentGeneralLedgerEdge>;
  /** A list of `RecentGeneralLedgersRecord` objects. */
  nodes: Array<RecentGeneralLedgersRecord>;
  /** The count of *all* `RecentGeneralLedgersRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** The return type of our `recentGeneralLedgers` query. */
export type RecentGeneralLedgersRecord = {
  __typename?: 'RecentGeneralLedgersRecord';
  draftLedger: Maybe<GeneralLedger>;
  finalLedger: Maybe<GeneralLedger>;
  fiscalYear: Maybe<Scalars['Int']>;
};

/** All input for the `rejectInvite` mutation. */
export type RejectInviteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviteLinkId: Scalars['UUID'];
};

/** The output of our `rejectInvite` mutation. */
export type RejectInvitePayload = {
  __typename?: 'RejectInvitePayload';
  /** Reads a single `Account` that is related to this `InviteLink`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  inviteLink: Maybe<InviteLink>;
  /** An edge for our `InviteLink`. May be used by Relay 1. */
  inviteLinkEdge: Maybe<InviteLinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Role` that is related to this `InviteLink`. */
  role: Maybe<Role>;
  /** Reads a single `User` that is related to this `InviteLink`. */
  user: Maybe<User>;
};

/** The output of our `rejectInvite` mutation. */
export type RejectInvitePayloadInviteLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<InviteLinksOrderBy>>;
};

export type Report = {
  __typename?: 'Report';
  /** Reads a single `Account` that is related to this `Report`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** The time that this Report completed generation. */
  completedAt: Maybe<Scalars['Datetime']>;
  /** The time that this Report was created. */
  createdAt: Scalars['Datetime'];
  /** Optional error details if there is an unrecoverable error while creating this Report. */
  errorDetails: Maybe<Scalars['String']>;
  /** Reads a single `FileTemplateVersion` that is related to this `Report`. */
  fileTemplateVersion: Maybe<FileTemplateVersion>;
  fileTemplateVersionId: Maybe<Scalars['UUID']>;
  /** Reads a single `FiscalYear` that is related to this `Report`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Maybe<Scalars['UUID']>;
  /** Reads a single `GeneralLedger` that is related to this `Report`. */
  generalLedger: Maybe<GeneralLedger>;
  generalLedgerId: Maybe<Scalars['UUID']>;
  /** Primary key of the Report. */
  id: Scalars['UUID'];
  /** Reads a single `JobResult` that is related to this `Report`. */
  job: Maybe<JobResult>;
  jobId: Maybe<Scalars['UUID']>;
  /** The name of the Report. */
  name: Scalars['String'];
  /** Reads a single `File` that is related to this `Report`. */
  reportFile: Maybe<File>;
  reportFileId: Maybe<Scalars['UUID']>;
  /** The current status of the Report. If "ERROR", investigate the error_details column for more information. */
  status: ReportStatus;
  /** The type of the Report. This will indicate what kind of information is available in the Report. */
  type: ReportType;
  /** Reads a single `User` that is related to this `Report`. */
  user: Maybe<User>;
  userId: Maybe<Scalars['UUID']>;
};

/** A condition to be used against `Report` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ReportCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `fileTemplateVersionId` field. */
  fileTemplateVersionId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `generalLedgerId` field. */
  generalLedgerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `jobId` field. */
  jobId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `reportFileId` field. */
  reportFileId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ReportStatus>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<ReportType>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum ReportStatus {
  Complete = 'COMPLETE',
  Error = 'ERROR',
  Generating = 'GENERATING',
  Scheduled = 'SCHEDULED',
}

export enum ReportType {
  Afr = 'AFR',
  Budget = 'BUDGET',
  BudgetRevision = 'BUDGET_REVISION',
  Csr = 'CSR',
  Cted = 'CTED',
  Idc = 'IDC',
}

/** A connection to a list of `Report` values. */
export type ReportsConnection = {
  __typename?: 'ReportsConnection';
  /** A list of edges which contains the `Report` and cursor to aid in pagination. */
  edges: Array<ReportsEdge>;
  /** A list of `Report` objects. */
  nodes: Array<Report>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Report` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Report` edge in the connection. */
export type ReportsEdge = {
  __typename?: 'ReportsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Report` at the end of the edge. */
  node: Report;
};

/** Methods to use when ordering `Report`. */
export enum ReportsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  FileTemplateVersionIdAsc = 'FILE_TEMPLATE_VERSION_ID_ASC',
  FileTemplateVersionIdDesc = 'FILE_TEMPLATE_VERSION_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  GeneralLedgerIdAsc = 'GENERAL_LEDGER_ID_ASC',
  GeneralLedgerIdDesc = 'GENERAL_LEDGER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  JobIdAsc = 'JOB_ID_ASC',
  JobIdDesc = 'JOB_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReportFileIdAsc = 'REPORT_FILE_ID_ASC',
  ReportFileIdDesc = 'REPORT_FILE_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TypeAsc = 'TYPE_ASC',
  TypeDesc = 'TYPE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

/** All input for the `requestAccountDeletion` mutation. */
export type RequestAccountDeletionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `requestAccountDeletion` mutation. */
export type RequestAccountDeletionPayload = {
  __typename?: 'RequestAccountDeletionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

/** All input for the `revokeInvite` mutation. */
export type RevokeInviteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  inviteLinkId: Scalars['UUID'];
};

/** The output of our `revokeInvite` mutation. */
export type RevokeInvitePayload = {
  __typename?: 'RevokeInvitePayload';
  /** Reads a single `Account` that is related to this `InviteLink`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  inviteLink: Maybe<InviteLink>;
  /** An edge for our `InviteLink`. May be used by Relay 1. */
  inviteLinkEdge: Maybe<InviteLinksEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `Role` that is related to this `InviteLink`. */
  role: Maybe<Role>;
  /** Reads a single `User` that is related to this `InviteLink`. */
  user: Maybe<User>;
};

/** The output of our `revokeInvite` mutation. */
export type RevokeInvitePayloadInviteLinkEdgeArgs = {
  orderBy?: InputMaybe<Array<InviteLinksOrderBy>>;
};

export type Role = {
  __typename?: 'Role';
  /** Reads and enables pagination through a set of `AccountMembership`. */
  accountMemberships: AccountMembershipsConnection;
  /** Description of the Role. */
  description: Maybe<Scalars['String']>;
  /** Primary key of the Role. */
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InviteLink`. */
  inviteLinks: InviteLinksConnection;
  /** Name of the Role. */
  name: Scalars['String'];
  /** Reads and enables pagination through a set of `RoleScope`. */
  roleScopes: RoleScopesConnection;
  /** Integer value of the role. The lower the value, the more permissive the role. */
  value: Maybe<Scalars['Int']>;
};

export type RoleAccountMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountMembershipCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountMembershipsOrderBy>>;
};

export type RoleInviteLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InviteLinkCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InviteLinksOrderBy>>;
};

export type RoleRoleScopesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleScopeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
};

/** A condition to be used against `Role` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type RoleCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

export type RoleScope = {
  __typename?: 'RoleScope';
  /** Reads a single `Role` that is related to this `RoleScope`. */
  role: Maybe<Role>;
  roleId: Scalars['UUID'];
  /** Reads a single `Scope` that is related to this `RoleScope`. */
  scope: Maybe<Scope>;
  scopeId: Scalars['UUID'];
};

/**
 * A condition to be used against `RoleScope` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type RoleScopeCondition = {
  /** Checks for equality with the object’s `roleId` field. */
  roleId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `scopeId` field. */
  scopeId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `RoleScope` values. */
export type RoleScopesConnection = {
  __typename?: 'RoleScopesConnection';
  /** A list of edges which contains the `RoleScope` and cursor to aid in pagination. */
  edges: Array<RoleScopesEdge>;
  /** A list of `RoleScope` objects. */
  nodes: Array<RoleScope>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RoleScope` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `RoleScope` edge in the connection. */
export type RoleScopesEdge = {
  __typename?: 'RoleScopesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `RoleScope` at the end of the edge. */
  node: RoleScope;
};

/** Methods to use when ordering `RoleScope`. */
export enum RoleScopesOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleIdAsc = 'ROLE_ID_ASC',
  RoleIdDesc = 'ROLE_ID_DESC',
  ScopeIdAsc = 'SCOPE_ID_ASC',
  ScopeIdDesc = 'SCOPE_ID_DESC',
}

/** A connection to a list of `Role` values. */
export type RolesConnection = {
  __typename?: 'RolesConnection';
  /** A list of edges which contains the `Role` and cursor to aid in pagination. */
  edges: Array<RolesEdge>;
  /** A list of `Role` objects. */
  nodes: Array<Role>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Role` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Role` edge in the connection. */
export type RolesEdge = {
  __typename?: 'RolesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Role` at the end of the edge. */
  node: Role;
};

/** Methods to use when ordering `Role`. */
export enum RolesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type School = {
  __typename?: 'School';
  /** Reads a single `Account` that is related to this `School`. */
  account: Maybe<Account>;
  accountId: Scalars['UUID'];
  /** The unique identifier for this school inside the AFR system. This is generated externally, and must be populated. */
  afrId: Maybe<Scalars['String']>;
  /** The ctds code of the school. */
  ctdsCode: Scalars['String'];
  /** Reads a single `FiscalYear` that is related to this `School`. */
  fiscalYear: Maybe<FiscalYear>;
  fiscalYearId: Scalars['UUID'];
  /** Primary key of the School. */
  id: Scalars['UUID'];
  /** Whether or not the school is a private school. */
  isPrivateSchool: Scalars['Boolean'];
  /** The name of the school. */
  name: Scalars['String'];
  /** The number of students in the school. */
  numStudents: Scalars['Int'];
  /** The primary unit code of the school. */
  primaryUnitCode: Scalars['String'];
  /** The unweighted attending student count for the school. */
  uasc: Scalars['Float'];
  /** All unit codes for the school. */
  unitCodes: Array<Maybe<Scalars['String']>>;
};

/** A condition to be used against `School` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SchoolCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fiscalYearId` field. */
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `School` values. */
export type SchoolsConnection = {
  __typename?: 'SchoolsConnection';
  /** A list of edges which contains the `School` and cursor to aid in pagination. */
  edges: Array<SchoolsEdge>;
  /** A list of `School` objects. */
  nodes: Array<School>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `School` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `School` edge in the connection. */
export type SchoolsEdge = {
  __typename?: 'SchoolsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `School` at the end of the edge. */
  node: School;
};

/** Methods to use when ordering `School`. */
export enum SchoolsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  FiscalYearIdAsc = 'FISCAL_YEAR_ID_ASC',
  FiscalYearIdDesc = 'FISCAL_YEAR_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type Scope = {
  __typename?: 'Scope';
  /** Primary key of the Scope. */
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `RoleScope`. */
  roleScopes: RoleScopesConnection;
  /** Value of the scope. */
  value: Scalars['String'];
};

export type ScopeRoleScopesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RoleScopeCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RoleScopesOrderBy>>;
};

/** A condition to be used against `Scope` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type ScopeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `Scope` values. */
export type ScopesConnection = {
  __typename?: 'ScopesConnection';
  /** A list of edges which contains the `Scope` and cursor to aid in pagination. */
  edges: Array<ScopesEdge>;
  /** A list of `Scope` objects. */
  nodes: Array<Scope>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Scope` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `Scope` edge in the connection. */
export type ScopesEdge = {
  __typename?: 'ScopesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `Scope` at the end of the edge. */
  node: Scope;
};

/** Methods to use when ordering `Scope`. */
export enum ScopesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

export type ScrapeAttemptWork = {
  __typename?: 'ScrapeAttemptWork';
  /** The run this token resolved to. */
  attemptId: Scalars['UUID'];
  /**
   * ScrapeJob[] (see @app/shared). JSON rather than a GraphQL union
   * because only the runner consumes it, and the shared TypeScript type
   * is what keeps the API, runner, and ingest task in agreement.
   */
  jobs: Scalars['JSON'];
};

/** A signed URL the scrape runner PUTs one downloaded report to. */
export type ScrapeUploadTarget = {
  __typename?: 'ScrapeUploadTarget';
  /**
   * The object path the file will land at. Echoed back on completion so
   * the server can ingest exactly what was uploaded.
   */
  gcsPath: Scalars['String'];
  /** The signed url to PUT the file to. */
  url: Scalars['String'];
};

export type SignedUrlForFileDownload = {
  __typename?: 'SignedUrlForFileDownload';
  /** The extension of the file */
  extension: Scalars['String'];
  /** The name of the file */
  name: Scalars['String'];
  /** The signed url to perform a download against */
  url: Scalars['String'];
};

/** The result of a signed url for downloading a report */
export type SignedUrlForReportDownload = {
  __typename?: 'SignedUrlForReportDownload';
  /** The signed url to perform a download against */
  url: Scalars['String'];
};

/** The result of a signed url build */
export type SignedUrlForUpload = {
  __typename?: 'SignedUrlForUpload';
  /** The id of the file created on the ledger */
  fileId: Scalars['UUID'];
  /** The signed url to perform an upload against */
  url: Scalars['String'];
};

export type SingleCodeCheckInput = {
  /**
   * The account code that will be evaluated against the USFR for the given
   * account and fiscal year.
   */
  accountCode: Scalars['String'];
  /** The ID of the account that the account code will be evaluated against. */
  accountId: Scalars['UUID'];
  /** The value of the fiscal year that the account code will be evaluated against. */
  fiscalYear: Scalars['Int'];
};

export type SingleCodeCheckResult = {
  __typename?: 'SingleCodeCheckResult';
  classification: Maybe<Scalars['String']>;
  details: Scalars['String'];
  originalAccountCode: Scalars['String'];
  severity: CodeCheckResultSeverity;
};

export type SpedRecord = {
  __typename?: 'SpedRecord';
  /** Reads a single `Account` that is related to this `SpedRecord`. */
  account: Maybe<Account>;
  accountId: Maybe<Scalars['UUID']>;
  /** The data from the "AggregationID" column of the SPED file. */
  aggregationId: Maybe<Scalars['String']>;
  /** The data from the "DataCaptureDate" column of the SPED file. */
  dataCaptureDate: Maybe<Scalars['String']>;
  /** The data from the "DisabilityCategory" column of the SPED file. */
  disabilityCategory: Maybe<Scalars['String']>;
  /** The data from the "DistrictOf" column of the SPED file. */
  districtOf: Maybe<Scalars['String']>;
  /** Reads a single `GeneralLedger` that is related to this `SpedRecord`. */
  generalLedger: Maybe<GeneralLedger>;
  generalLedgerId: Maybe<Scalars['UUID']>;
  /** Primary key of the SPEDRecord. */
  id: Scalars['UUID'];
  /** The data from the "LEA_CTDS" column of the SPED file. */
  leaCtds: Maybe<Scalars['String']>;
  /** The data from the "LEAName" column of the SPED file. */
  leaName: Maybe<Scalars['String']>;
  /** The data from the "ReportType" column of the SPED file. */
  reportType: Maybe<Scalars['String']>;
  /** The data from the "ReportingPeriod" column of the SPED file. */
  reportingPeriod: Maybe<Scalars['String']>;
  /** The data from the "ResourceADM" column of the SPED file. */
  resourceAdm: Maybe<Scalars['String']>;
  /** The data from the "SchoolCTDS" column of the SPED file. */
  schoolCtds: Maybe<Scalars['String']>;
  /** The data from the "SchoolName" column of the SPED file. */
  schoolName: Maybe<Scalars['String']>;
  /** The data from the "SelfContainedADM" column of the SPED file. */
  selfContainedAdm: Maybe<Scalars['String']>;
  /** The type of file that this record came from. At the time of writing, we expect this to be either SPED20 or SPED30. */
  source: Scalars['String'];
  /** The data from the "SPEDWeight" column of the SPED file. */
  spedWeight: Maybe<Scalars['String']>;
};

/**
 * A condition to be used against `SpedRecord` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SpedRecordCondition = {
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `generalLedgerId` field. */
  generalLedgerId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `SpedRecord` values. */
export type SpedRecordsConnection = {
  __typename?: 'SpedRecordsConnection';
  /** A list of edges which contains the `SpedRecord` and cursor to aid in pagination. */
  edges: Array<SpedRecordsEdge>;
  /** A list of `SpedRecord` objects. */
  nodes: Array<SpedRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SpedRecord` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `SpedRecord` edge in the connection. */
export type SpedRecordsEdge = {
  __typename?: 'SpedRecordsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `SpedRecord` at the end of the edge. */
  node: SpedRecord;
};

/** Methods to use when ordering `SpedRecord`. */
export enum SpedRecordsOrderBy {
  AccountIdAsc = 'ACCOUNT_ID_ASC',
  AccountIdDesc = 'ACCOUNT_ID_DESC',
  GeneralLedgerIdAsc = 'GENERAL_LEDGER_ID_ASC',
  GeneralLedgerIdDesc = 'GENERAL_LEDGER_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/** All input for the `startFutureJob` mutation. */
export type StartFutureJobInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  jobId: Scalars['UUID'];
};

/** The output of our `startFutureJob` mutation. */
export type StartFutureJobPayload = {
  __typename?: 'StartFutureJobPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  newJobKey: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `startGeneratingReport` mutation. */
export type StartGeneratingReportInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  ledgerId: Scalars['UUID'];
};

/** The output of our `startGeneratingReport` mutation. */
export type StartGeneratingReportPayload = {
  __typename?: 'StartGeneratingReportPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `startProcessingLedger` mutation. */
export type StartProcessingLedgerInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  generateCtedReport?: InputMaybe<Scalars['Boolean']>;
  generateIdcReport?: InputMaybe<Scalars['Boolean']>;
  ledgerId: Scalars['UUID'];
};

/** The output of our `startProcessingLedger` mutation. */
export type StartProcessingLedgerPayload = {
  __typename?: 'StartProcessingLedgerPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** All input for the `startProcessingPreviousAfr` mutation. */
export type StartProcessingPreviousAfrInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fiscalYearId: Scalars['UUID'];
};

/** The output of our `startProcessingPreviousAfr` mutation. */
export type StartProcessingPreviousAfrPayload = {
  __typename?: 'StartProcessingPreviousAfrPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  jobId: Maybe<Scalars['UUID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

export type StartScrapeRunResult = {
  __typename?: 'StartScrapeRunResult';
  /** Correlates this run's log lines. Not a database key. */
  attemptId: Scalars['UUID'];
  /** The signed token the runner authenticates with. */
  runToken: Scalars['String'];
  /** How many district/fiscal-year targets are currently due. */
  targetCount: Scalars['Int'];
};

export type State = {
  __typename?: 'State';
  /** Reads and enables pagination through a set of `Account`. */
  accounts: AccountsConnection;
  /** The 2 character abbreviation of the U.S. state. */
  code: Scalars['String'];
  /** Reads and enables pagination through a set of `FileTemplateVersion`. */
  fileTemplateVersions: FileTemplateVersionsConnection;
  /** Primary key of the State. */
  id: Scalars['UUID'];
  /** The full name of the U.S. state. */
  name: Scalars['String'];
};

export type StateAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

export type StateFileTemplateVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FileTemplateVersionCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FileTemplateVersionsOrderBy>>;
};

/** A condition to be used against `State` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type StateCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `State` values. */
export type StatesConnection = {
  __typename?: 'StatesConnection';
  /** A list of edges which contains the `State` and cursor to aid in pagination. */
  edges: Array<StatesEdge>;
  /** A list of `State` objects. */
  nodes: Array<State>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `State` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `State` edge in the connection. */
export type StatesEdge = {
  __typename?: 'StatesEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `State` at the end of the edge. */
  node: State;
};

/** Methods to use when ordering `State`. */
export enum StatesOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
}

/** All input for the `submitHelpTicket` mutation. */
export type SubmitHelpTicketInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  subject: HelpTicketSubject;
  userProvidedSubject?: InputMaybe<Scalars['String']>;
};

/** The output of our `submitHelpTicket` mutation. */
export type SubmitHelpTicketPayload = {
  __typename?: 'SubmitHelpTicketPayload';
  /** Reads a single `Account` that is related to this `HelpTicket`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  helpTicket: Maybe<HelpTicket>;
  /** An edge for our `HelpTicket`. May be used by Relay 1. */
  helpTicketEdge: Maybe<HelpTicketsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `User` that is related to this `HelpTicket`. */
  user: Maybe<User>;
};

/** The output of our `submitHelpTicket` mutation. */
export type SubmitHelpTicketPayloadHelpTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<HelpTicketsOrderBy>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when a account is updated! */
  accountUpdated: Maybe<AccountUpdateSubscriptionPayload>;
  /** Triggered when the logged in user's record is updated in some way. */
  currentUserUpdated: Maybe<UserSubscriptionPayload>;
  /** Triggered when a job result is updated! */
  jobResultUpdated: Maybe<JobResultSubscriptionPayload>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionAccountUpdatedArgs = {
  accountId: Scalars['UUID'];
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionJobResultUpdatedArgs = {
  id: Scalars['UUID'];
};

/** All input for the `updateAccountFeatureExpiration` mutation. */
export type UpdateAccountFeatureExpirationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  pAccountId: Scalars['UUID'];
  pFeatureId: Scalars['UUID'];
  pNewExpiresAt?: InputMaybe<Scalars['Datetime']>;
};

/** The output of our `updateAccountFeatureExpiration` mutation. */
export type UpdateAccountFeatureExpirationPayload = {
  __typename?: 'UpdateAccountFeatureExpirationPayload';
  /** Reads a single `Account` that is related to this `AccountFeature`. */
  account: Maybe<Account>;
  accountFeature: Maybe<AccountFeature>;
  /** An edge for our `AccountFeature`. May be used by Relay 1. */
  accountFeatureEdge: Maybe<AccountFeaturesEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `Feature` that is related to this `AccountFeature`. */
  feature: Maybe<Feature>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our `updateAccountFeatureExpiration` mutation. */
export type UpdateAccountFeatureExpirationPayloadAccountFeatureEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountFeaturesOrderBy>>;
};

/** All input for the `updateAccount` mutation. */
export type UpdateAccountInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  newName?: InputMaybe<Scalars['String']>;
  newStateCode?: InputMaybe<Scalars['String']>;
};

/** The output of our `updateAccount` mutation. */
export type UpdateAccountPayload = {
  __typename?: 'UpdateAccountPayload';
  account: Maybe<Account>;
  /** An edge for our `Account`. May be used by Relay 1. */
  accountEdge: Maybe<AccountsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `State` that is related to this `Account`. */
  state: Maybe<State>;
};

/** The output of our `updateAccount` mutation. */
export type UpdateAccountPayloadAccountEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};

/** All input for the `updateAccountSettings` mutation. */
export type UpdateAccountSettingsInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fiscalYearId: Scalars['UUID'];
  newAfrWebsite?: InputMaybe<Scalars['String']>;
  newCounty?: InputMaybe<Scalars['String']>;
  newCtdsCode?: InputMaybe<Scalars['String']>;
  newFileIngestOverrides?: InputMaybe<Scalars['JSON']>;
  newFileProcessingOverrides?: InputMaybe<Scalars['JSON']>;
  newHasDesegregation?: InputMaybe<Scalars['Boolean']>;
  newHasFoodService?: InputMaybe<Scalars['Boolean']>;
  newIifValue?: InputMaybe<Scalars['String']>;
  newPrimaryUnitCode?: InputMaybe<Scalars['String']>;
  newSchoolLevelAllocation?: InputMaybe<Scalars['Boolean']>;
  newSingleSchoolDistrict?: InputMaybe<Scalars['Boolean']>;
  newThreeOrLessYearsTeacherCount?: InputMaybe<Scalars['Int']>;
  newTotalTeacherCount?: InputMaybe<Scalars['Int']>;
};

/** The output of our `updateAccountSettings` mutation. */
export type UpdateAccountSettingsPayload = {
  __typename?: 'UpdateAccountSettingsPayload';
  /** Reads a single `Account` that is related to this `AccountFiscalYear`. */
  account: Maybe<Account>;
  /** An edge for our `AccountFiscalYear`. May be used by Relay 1. */
  accountFiscalYearEdge: Maybe<AccountFiscalYearsEdge>;
  accountSettings: Maybe<AccountFiscalYear>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  adoptedBudgetFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  bsa21File: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  bsa55File: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  budg75File: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  budgetFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  budgetRevisionExtractedDataFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  chartOfAccountsFile: Maybe<File>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  desegBudgetFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  externalBudgetDataFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  externalBudgetRevisionDataFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  finalAfrFile: Maybe<File>;
  /** Reads a single `FiscalYear` that is related to this `AccountFiscalYear`. */
  fiscalYear: Maybe<FiscalYear>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  prevYearAfrFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  prevYearDesegAfrFile: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  prevYearFoodServiceAfrFile: Maybe<File>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  sped20File: Maybe<File>;
  /** Reads a single `File` that is related to this `AccountFiscalYear`. */
  sped30File: Maybe<File>;
};

/** The output of our `updateAccountSettings` mutation. */
export type UpdateAccountSettingsPayloadAccountFiscalYearEdgeArgs = {
  orderBy?: InputMaybe<Array<AccountFiscalYearsOrderBy>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  newMarketingConsent?: InputMaybe<Scalars['Boolean']>;
  newName?: InputMaybe<Scalars['String']>;
  newSettings?: InputMaybe<Scalars['JSON']>;
};

/** The output of our `updateUser` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

/** All input for the `upsertDistrictContact` mutation. */
export type UpsertDistrictContactInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactId?: InputMaybe<Scalars['UUID']>;
  newEmail?: InputMaybe<Scalars['String']>;
  newExtension?: InputMaybe<Scalars['String']>;
  newFirstName?: InputMaybe<Scalars['String']>;
  newFiscalYearId?: InputMaybe<Scalars['UUID']>;
  newLastName?: InputMaybe<Scalars['String']>;
  newPhone?: InputMaybe<Scalars['String']>;
  newPrefix?: InputMaybe<Scalars['String']>;
  newTitle?: InputMaybe<Scalars['String']>;
};

/** The output of our `upsertDistrictContact` mutation. */
export type UpsertDistrictContactPayload = {
  __typename?: 'UpsertDistrictContactPayload';
  /** Reads a single `Account` that is related to this `DistrictContact`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  districtContact: Maybe<DistrictContact>;
  /** An edge for our `DistrictContact`. May be used by Relay 1. */
  districtContactEdge: Maybe<DistrictContactsEdge>;
  /** Reads a single `FiscalYear` that is related to this `DistrictContact`. */
  fiscalYear: Maybe<FiscalYear>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our `upsertDistrictContact` mutation. */
export type UpsertDistrictContactPayloadDistrictContactEdgeArgs = {
  orderBy?: InputMaybe<Array<DistrictContactsOrderBy>>;
};

/** All input for the `upsertFutureJob` mutation. */
export type UpsertFutureJobInput = {
  accountId: Scalars['UUID'];
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  fiscalYearId: Scalars['UUID'];
  taskData?: InputMaybe<Scalars['JSON']>;
  taskName: Scalars['String'];
};

/** The output of our `upsertFutureJob` mutation. */
export type UpsertFutureJobPayload = {
  __typename?: 'UpsertFutureJobPayload';
  /** Reads a single `Account` that is related to this `FutureJob`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `FiscalYear` that is related to this `FutureJob`. */
  fiscalYear: Maybe<FiscalYear>;
  futureJob: Maybe<FutureJob>;
  /** An edge for our `FutureJob`. May be used by Relay 1. */
  futureJobEdge: Maybe<FutureJobsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
};

/** The output of our `upsertFutureJob` mutation. */
export type UpsertFutureJobPayloadFutureJobEdgeArgs = {
  orderBy?: InputMaybe<Array<FutureJobsOrderBy>>;
};

/** All input for the `upsertSchool` mutation. */
export type UpsertSchoolInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  newAfrId?: InputMaybe<Scalars['String']>;
  newCtdsCode?: InputMaybe<Scalars['String']>;
  newFiscalYearId?: InputMaybe<Scalars['UUID']>;
  newIsPrivateSchool?: InputMaybe<Scalars['Boolean']>;
  newName?: InputMaybe<Scalars['String']>;
  newNumStudents?: InputMaybe<Scalars['Int']>;
  newPrimaryUnitCode?: InputMaybe<Scalars['String']>;
  newUasc?: InputMaybe<Scalars['Float']>;
  newUnitCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  schoolId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `upsertSchool` mutation. */
export type UpsertSchoolPayload = {
  __typename?: 'UpsertSchoolPayload';
  /** Reads a single `Account` that is related to this `School`. */
  account: Maybe<Account>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Reads a single `FiscalYear` that is related to this `School`. */
  fiscalYear: Maybe<FiscalYear>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  school: Maybe<School>;
  /** An edge for our `School`. May be used by Relay 1. */
  schoolEdge: Maybe<SchoolsEdge>;
};

/** The output of our `upsertSchool` mutation. */
export type UpsertSchoolPayloadSchoolEdgeArgs = {
  orderBy?: InputMaybe<Array<SchoolsOrderBy>>;
};

/** A user who can log in to the application. */
export type User = {
  __typename?: 'User';
  /** Reads and enables pagination through a set of `AccountMembership`. */
  accountMemberships: AccountMembershipsConnection;
  /** Optional avatar URL. */
  avatarUrl: Maybe<Scalars['String']>;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `File`. */
  files: FilesConnection;
  /** Reads and enables pagination through a set of `GeneralLedger`. */
  generalLedgers: GeneralLedgersConnection;
  /** A boolean value indicating whether the user has accepted the terms of use. */
  hasAcceptedTerms: Maybe<Scalars['Boolean']>;
  /** A boolean value indicating whether the user has given marketing consent. */
  hasGivenMarketingConsent: Maybe<Scalars['Boolean']>;
  hasPassword: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `HelpTicket`. */
  helpTickets: HelpTicketsConnection;
  /** Unique identifier for the user. */
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `InviteLink`. */
  inviteLinks: InviteLinksConnection;
  isServiceUser: Scalars['Boolean'];
  /** If true, the user has elevated privileges. */
  isSystemAdmin: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `JobResult`. */
  jobResults: JobResultsConnection;
  /** Public-facing name (or pseudonym) of the user. */
  name: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Notification`. */
  notifications: NotificationsConnection;
  /** Reads and enables pagination through a set of `Report`. */
  reports: ReportsConnection;
  /** All of the settings for the current user. */
  settings: Maybe<Scalars['JSON']>;
  updatedAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `UserAuthentication`. */
  userAuthenticationsList: Array<UserAuthentication>;
  /** Reads and enables pagination through a set of `UserEmail`. */
  userEmails: UserEmailsConnection;
  /** Public-facing username (or 'handle') of the user. */
  username: Maybe<Scalars['String']>;
  /** Reads a single `UsersOwner` that is related to this `User`. */
  usersOwnerByUsersId: Maybe<UsersOwner>;
};

/** A user who can log in to the application. */
export type UserAccountMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<AccountMembershipCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AccountMembershipsOrderBy>>;
};

/** A user who can log in to the application. */
export type UserFilesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FileCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FilesOrderBy>>;
};

/** A user who can log in to the application. */
export type UserGeneralLedgersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GeneralLedgerCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GeneralLedgersOrderBy>>;
};

/** A user who can log in to the application. */
export type UserHelpTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<HelpTicketCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<HelpTicketsOrderBy>>;
};

/** A user who can log in to the application. */
export type UserInviteLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<InviteLinkCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InviteLinksOrderBy>>;
};

/** A user who can log in to the application. */
export type UserJobResultsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<JobResultCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<JobResultsOrderBy>>;
};

/** A user who can log in to the application. */
export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<NotificationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<NotificationsOrderBy>>;
};

/** A user who can log in to the application. */
export type UserReportsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ReportCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ReportsOrderBy>>;
};

/** A user who can log in to the application. */
export type UserUserAuthenticationsListArgs = {
  condition?: InputMaybe<UserAuthenticationCondition>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserAuthenticationsOrderBy>>;
};

/** A user who can log in to the application. */
export type UserUserEmailsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserEmailCondition>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserEmailsOrderBy>>;
};

/** Contains information about the login providers this user has used, so that they may disconnect them should they wish. */
export type UserAuthentication = {
  __typename?: 'UserAuthentication';
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** A unique identifier for the user within the login service. */
  identifier: Scalars['String'];
  /** The login service used, e.g. `twitter` or `github`. */
  service: Scalars['String'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserAuthentication`. */
  user: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `UserAuthentication` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserAuthenticationCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `service` field. */
  service?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Methods to use when ordering `UserAuthentication`. */
export enum UserAuthenticationsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceAsc = 'SERVICE_ASC',
  ServiceDesc = 'SERVICE_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

/** Information about a user's email address. */
export type UserEmail = {
  __typename?: 'UserEmail';
  createdAt: Scalars['Datetime'];
  /** The users email address, in `a@b.c` format. */
  email: Scalars['String'];
  id: Scalars['UUID'];
  isPrimary: Scalars['Boolean'];
  /** True if the user has is_verified their email address (by clicking the link in the email we sent them, or logging in with a social login provider), false otherwise. */
  isVerified: Scalars['Boolean'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserEmail`. */
  user: Maybe<User>;
  userId: Scalars['UUID'];
};

/**
 * A condition to be used against `UserEmail` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UserEmailCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isPrimary` field. */
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `UserEmail` values. */
export type UserEmailsConnection = {
  __typename?: 'UserEmailsConnection';
  /** A list of edges which contains the `UserEmail` and cursor to aid in pagination. */
  edges: Array<UserEmailsEdge>;
  /** A list of `UserEmail` objects. */
  nodes: Array<UserEmail>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserEmail` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UserEmail` edge in the connection. */
export type UserEmailsEdge = {
  __typename?: 'UserEmailsEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UserEmail` at the end of the edge. */
  node: UserEmail;
};

/** Methods to use when ordering `UserEmail`. */
export enum UserEmailsOrderBy {
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  IsPrimaryAsc = 'IS_PRIMARY_ASC',
  IsPrimaryDesc = 'IS_PRIMARY_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UserIdAsc = 'USER_ID_ASC',
  UserIdDesc = 'USER_ID_DESC',
}

export type UserSubscriptionPayload = {
  __typename?: 'UserSubscriptionPayload';
  event: Maybe<Scalars['String']>;
  user: Maybe<User>;
};

export type UsersOwner = {
  __typename?: 'UsersOwner';
  /** A boolean value indicating whether the user has accepted the terms of use. */
  hasAcceptedTerms: Maybe<Scalars['Boolean']>;
  /** A boolean value indicating whether the user has given marketing consent. */
  hasGivenMarketingConsent: Maybe<Scalars['Boolean']>;
  /** All of the settings for the current user. */
  settings: Maybe<Scalars['JSON']>;
  /** Reads a single `User` that is related to this `UsersOwner`. */
  users: Maybe<User>;
  usersId: Scalars['UUID'];
};

/**
 * A condition to be used against `UsersOwner` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type UsersOwnerCondition = {
  /** Checks for equality with the object’s `usersId` field. */
  usersId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `UsersOwner` values. */
export type UsersOwnersConnection = {
  __typename?: 'UsersOwnersConnection';
  /** A list of edges which contains the `UsersOwner` and cursor to aid in pagination. */
  edges: Array<UsersOwnersEdge>;
  /** A list of `UsersOwner` objects. */
  nodes: Array<UsersOwner>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UsersOwner` you could get from the connection. */
  totalCount: Scalars['Int'];
};

/** A `UsersOwner` edge in the connection. */
export type UsersOwnersEdge = {
  __typename?: 'UsersOwnersEdge';
  /** A cursor for use in pagination. */
  cursor: Maybe<Scalars['Cursor']>;
  /** The `UsersOwner` at the end of the edge. */
  node: UsersOwner;
};

/** Methods to use when ordering `UsersOwner`. */
export enum UsersOwnersOrderBy {
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UsersIdAsc = 'USERS_ID_ASC',
  UsersIdDesc = 'USERS_ID_DESC',
}

/** All input for the `verifyEmail` mutation. */
export type VerifyEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  userEmailId: Scalars['UUID'];
};

/** The output of our `verifyEmail` mutation. */
export type VerifyEmailPayload = {
  __typename?: 'VerifyEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query: Maybe<Query>;
  success: Maybe<Scalars['Boolean']>;
};

export type AcceptInviteMutationVariables = Exact<{
  inviteLinkId: Scalars['UUID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
}>;

export type AcceptInviteMutation = {
  __typename?: 'Mutation';
  acceptInvite: {
    __typename?: 'AcceptInvitePayload';
    clientMutationId: string | null;
    inviteLink: {
      __typename?: 'InviteLink';
      id: any;
      state: InviteState;
    } | null;
  } | null;
};

export type AcceptTermsMutationVariables = Exact<{
  clientMutationId?: InputMaybe<Scalars['String']>;
}>;

export type AcceptTermsMutation = {
  __typename?: 'Mutation';
  acceptTerms: {
    __typename?: 'AcceptTermsPayload';
    clientMutationId: string | null;
    success: boolean | null;
  } | null;
};

export type AcknowledgeNotificationMutationVariables = Exact<{
  input: AcknowledgeNotificationInput;
}>;

export type AcknowledgeNotificationMutation = {
  __typename?: 'Mutation';
  acknowledgeNotification: {
    __typename?: 'AcknowledgeNotificationPayload';
    success: boolean | null;
  } | null;
};

export type DownloadFileMutationVariables = Exact<{
  fileId: Scalars['UUID'];
}>;

export type DownloadFileMutation = {
  __typename?: 'Mutation';
  buildFileDownloadUrl: {
    __typename?: 'SignedUrlForFileDownload';
    url: string;
    name: string;
    extension: string;
  } | null;
};

export type CreateGeneralLedgerMutationVariables = Exact<{
  input: CreateGeneralLedgerInput;
}>;

export type CreateGeneralLedgerMutation = {
  __typename?: 'Mutation';
  createGeneralLedger: {
    __typename?: 'CreateGeneralLedgerPayload';
    clientMutationId: string | null;
    generalLedger: {
      __typename?: 'GeneralLedger';
      id: any;
      status: GeneralLedgerStatus;
    } | null;
  } | null;
};

export type BuildSignedUrlForLedgerMutationVariables = Exact<{
  input: BuildSignedUrlForLedgerInput;
}>;

export type BuildSignedUrlForLedgerMutation = {
  __typename?: 'Mutation';
  buildSignedUrlForLedger: {
    __typename?: 'SignedUrlForUpload';
    fileId: any;
    url: string;
  } | null;
};

export type MarkFileUploadedMutationVariables = Exact<{
  input: MarkFileUploadedInput;
}>;

export type MarkFileUploadedMutation = {
  __typename?: 'Mutation';
  markFileUploaded: {
    __typename?: 'MarkFileUploadedPayload';
    clientMutationId: string | null;
    success: boolean | null;
  } | null;
};

export type StartProcessingLedgerMutationVariables = Exact<{
  input: StartProcessingLedgerInput;
}>;

export type StartProcessingLedgerMutation = {
  __typename?: 'Mutation';
  startProcessingLedger: {
    __typename?: 'StartProcessingLedgerPayload';
    clientMutationId: string | null;
    jobId: any | null;
  } | null;
};

export type GenerateBudgetRevisionReportMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
}>;

export type GenerateBudgetRevisionReportMutation = {
  __typename?: 'Mutation';
  generateBudgetRevisionReport: {
    __typename?: 'GenerateBudgetRevisionReportPayload';
    clientMutationId: string | null;
    jobId: any | null;
  } | null;
};

export type GenerateCsrReportMutationVariables = Exact<{
  ledgerId: Scalars['UUID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
}>;

export type GenerateCsrReportMutation = {
  __typename?: 'Mutation';
  generateCsrReport: {
    __typename?: 'GenerateCsrReportPayload';
    clientMutationId: string | null;
    jobId: any | null;
  } | null;
};

export type GenerateCtedReportMutationVariables = Exact<{
  ledgerId: Scalars['UUID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
}>;

export type GenerateCtedReportMutation = {
  __typename?: 'Mutation';
  generateCtedReport: {
    __typename?: 'GenerateCtedReportPayload';
    clientMutationId: string | null;
    jobId: any | null;
  } | null;
};

export type GenerateIndirectCostReportMutationVariables = Exact<{
  ledgerId: Scalars['UUID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
}>;

export type GenerateIndirectCostReportMutation = {
  __typename?: 'Mutation';
  generateIndirectCostReport: {
    __typename?: 'GenerateIndirectCostReportPayload';
    clientMutationId: string | null;
    jobId: any | null;
  } | null;
};

export type StartGeneratingReportMutationVariables = Exact<{
  ledgerId: Scalars['UUID'];
}>;

export type StartGeneratingReportMutation = {
  __typename?: 'Mutation';
  startGeneratingReport: {
    __typename?: 'StartGeneratingReportPayload';
    clientMutationId: string | null;
    jobId: any | null;
  } | null;
};

export type LedgerWithReportQueryVariables = Exact<{
  ledgerId: Scalars['UUID'];
}>;

export type LedgerWithReportQuery = {
  __typename?: 'Query';
  generalLedger: {
    __typename?: 'GeneralLedger';
    id: any;
    displayName: string;
    reports: {
      __typename?: 'ReportsConnection';
      nodes: Array<{
        __typename?: 'Report';
        id: any;
        name: string;
        errorDetails: string | null;
        status: ReportStatus;
        jobId: any | null;
        type: ReportType;
        createdAt: string;
        reportFile: {
          __typename?: 'File';
          id: any;
          extension: string | null;
          name: string | null;
          size: any;
          uploaded: boolean;
        } | null;
      }>;
    };
  } | null;
};

export type GenerateReportJobResultQueryVariables = Exact<{
  jobId: Scalars['UUID'];
}>;

export type GenerateReportJobResultQuery = {
  __typename?: 'Query';
  jobResult: {
    __typename?: 'JobResult';
    id: any;
    result: { [key: string]: any } | null;
    status: string;
  } | null;
};

export type DownloadReportMutationVariables = Exact<{
  reportId: Scalars['UUID'];
}>;

export type DownloadReportMutation = {
  __typename?: 'Mutation';
  buildReportDownloadUrl: {
    __typename?: 'SignedUrlForReportDownload';
    url: string;
  } | null;
};

export type InviteUserToAccountMutationVariables = Exact<{
  email: Scalars['String'];
  accountId: Scalars['UUID'];
  roleId: Scalars['UUID'];
}>;

export type InviteUserToAccountMutation = {
  __typename?: 'Mutation';
  inviteToAccount: {
    __typename?: 'InviteToAccountPayload';
    clientMutationId: string | null;
    jobId: any | null;
  } | null;
};

export type KickMemberMutationVariables = Exact<{
  membershipId: Scalars['UUID'];
}>;

export type KickMemberMutation = {
  __typename?: 'Mutation';
  kickMember: {
    __typename?: 'KickMemberPayload';
    clientMutationId: string | null;
    success: boolean | null;
  } | null;
};

export type LeaveEntityMutationVariables = Exact<{
  accountId: Scalars['UUID'];
}>;

export type LeaveEntityMutation = {
  __typename?: 'Mutation';
  leaveAccount: {
    __typename?: 'LeaveAccountPayload';
    clientMutationId: string | null;
    success: boolean | null;
  } | null;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = {
  __typename?: 'Mutation';
  logout: {
    __typename?: 'LogoutPayload';
    success: boolean | null;
    logoutUrl: string | null;
  } | null;
};

export type RejectInviteMutationVariables = Exact<{
  inviteLinkId: Scalars['UUID'];
  clientMutationId?: InputMaybe<Scalars['String']>;
}>;

export type RejectInviteMutation = {
  __typename?: 'Mutation';
  rejectInvite: {
    __typename?: 'RejectInvitePayload';
    clientMutationId: string | null;
    inviteLink: {
      __typename?: 'InviteLink';
      id: any;
      state: InviteState;
    } | null;
  } | null;
};

export type RevokeInviteMutationVariables = Exact<{
  inviteLinkId: Scalars['UUID'];
}>;

export type RevokeInviteMutation = {
  __typename?: 'Mutation';
  revokeInvite: {
    __typename?: 'RevokeInvitePayload';
    clientMutationId: string | null;
  } | null;
};

export type UpsertSchoolMutationVariables = Exact<{
  input: UpsertSchoolInput;
}>;

export type UpsertSchoolMutation = {
  __typename?: 'Mutation';
  upsertSchool: {
    __typename?: 'UpsertSchoolPayload';
    school: { __typename?: 'School'; id: any } | null;
  } | null;
};

export type DeleteSchoolMutationVariables = Exact<{
  schoolId: Scalars['UUID'];
}>;

export type DeleteSchoolMutation = {
  __typename?: 'Mutation';
  deleteSchool: {
    __typename?: 'DeleteSchoolPayload';
    success: boolean | null;
  } | null;
};

export type SingleCodeCheckMutationVariables = Exact<{
  accountCode: Scalars['String'];
  accountId: Scalars['UUID'];
  fiscalYear: Scalars['Int'];
}>;

export type SingleCodeCheckMutation = {
  __typename?: 'Mutation';
  singleCodeCheck: Array<{
    __typename?: 'SingleCodeCheckResult';
    classification: string | null;
    details: string;
    originalAccountCode: string;
    severity: CodeCheckResultSeverity;
  }> | null;
};

export type StartFutureJobMutationVariables = Exact<{
  input: StartFutureJobInput;
}>;

export type StartFutureJobMutation = {
  __typename?: 'Mutation';
  startFutureJob: {
    __typename?: 'StartFutureJobPayload';
    newJobKey: any | null;
  } | null;
};

export type StartScrapeRunMutationVariables = Exact<{ [key: string]: never }>;

export type StartScrapeRunMutation = {
  __typename?: 'Mutation';
  startScrapeRun: {
    __typename?: 'StartScrapeRunResult';
    attemptId: any;
    runToken: string;
    targetCount: number;
  } | null;
};

export type SubmitHelpTicketMutationVariables = Exact<{
  input: SubmitHelpTicketInput;
}>;

export type SubmitHelpTicketMutation = {
  __typename?: 'Mutation';
  submitHelpTicket: {
    __typename?: 'SubmitHelpTicketPayload';
    clientMutationId: string | null;
    helpTicket: { __typename?: 'HelpTicket'; id: any } | null;
  } | null;
};

export type UpdateAccountFeatureExpirationMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  featureId: Scalars['UUID'];
  newExpiresAt?: InputMaybe<Scalars['Datetime']>;
}>;

export type UpdateAccountFeatureExpirationMutation = {
  __typename?: 'Mutation';
  updateAccountFeatureExpiration: {
    __typename?: 'UpdateAccountFeatureExpirationPayload';
    accountFeature: {
      __typename?: 'AccountFeature';
      accountId: any | null;
      featureId: any | null;
      expiresAt: string | null;
    } | null;
  } | null;
};

export type UpdateAfrWebsiteMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newAfrWebsite: Scalars['String'];
}>;

export type UpdateAfrWebsiteMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      afrWebsite: string | null;
    } | null;
  } | null;
};

export type UpdateCountyMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newCounty: Scalars['String'];
}>;

export type UpdateCountyMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      county: string;
    } | null;
  } | null;
};

export type UpdateCtdsCodeMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newCtdsCode: Scalars['String'];
}>;

export type UpdateCtdsCodeMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      ctdsCode: string;
    } | null;
  } | null;
};

export type UpdateDesegMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newHasDesegregation: Scalars['Boolean'];
}>;

export type UpdateDesegMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      hasDesegregation: boolean | null;
    } | null;
  } | null;
};

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars['String'];
  emailId: Scalars['String'];
}>;

export type UpdateEmailMutation = {
  __typename?: 'Mutation';
  changeUserEmail: {
    __typename?: 'ChangeUserEmailPayload';
    success: boolean | null;
  } | null;
};

export type UpdateFoodServiceMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newHasFoodService: Scalars['Boolean'];
}>;

export type UpdateFoodServiceMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      hasFoodService: boolean | null;
    } | null;
  } | null;
};

export type UpdateFullNameMutationVariables = Exact<{
  newName: Scalars['String'];
}>;

export type UpdateFullNameMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'UpdateUserPayload';
    clientMutationId: string | null;
    success: boolean | null;
  } | null;
};

export type UpdateIifValueMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newIIFValue: Scalars['String'];
}>;

export type UpdateIifValueMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      iifValue: string | null;
    } | null;
  } | null;
};

export type UpdateMarketingConsentMutationVariables = Exact<{
  newMarketingConsent: Scalars['Boolean'];
}>;

export type UpdateMarketingConsentMutation = {
  __typename?: 'Mutation';
  updateUser: {
    __typename?: 'UpdateUserPayload';
    clientMutationId: string | null;
    success: boolean | null;
  } | null;
};

export type UpdatePrimaryUnitCodeMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newPrimaryUnitCode: Scalars['String'];
}>;

export type UpdatePrimaryUnitCodeMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      primaryUnitCode: string;
    } | null;
  } | null;
};

export type UpdateSchoolLevelAllocationMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newSchoolLevelAllocation: Scalars['Boolean'];
}>;

export type UpdateSchoolLevelAllocationMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      schoolLevelAllocation: boolean | null;
    } | null;
  } | null;
};

export type UpdateSingleSchoolDistrictMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newSingleSchoolDistrict: Scalars['Boolean'];
}>;

export type UpdateSingleSchoolDistrictMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      singleSchoolDistrict: boolean | null;
    } | null;
  } | null;
};

export type UpdateThreeOrLessYearsTeacherCountMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newThreeOrLessYearsTeacherCount: Scalars['Int'];
}>;

export type UpdateThreeOrLessYearsTeacherCountMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      threeOrLessYearsTeacherCount: number;
    } | null;
  } | null;
};

export type UpdateTotalTeacherCountMutationVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  newTotalTeacherCount: Scalars['Int'];
}>;

export type UpdateTotalTeacherCountMutation = {
  __typename?: 'Mutation';
  updateAccountSettings: {
    __typename?: 'UpdateAccountSettingsPayload';
    accountSettings: {
      __typename?: 'AccountFiscalYear';
      totalTeacherCount: number;
    } | null;
  } | null;
};

export type UpdateUserMembershipMutationVariables = Exact<{
  membershipId: Scalars['UUID'];
  toRole: Scalars['UUID'];
}>;

export type UpdateUserMembershipMutation = {
  __typename?: 'Mutation';
  changeMemberRole: {
    __typename?: 'ChangeMemberRolePayload';
    clientMutationId: string | null;
  } | null;
};

export type BuildSignedUrlForAccountMutationVariables = Exact<{
  input: BuildSignedUrlForAccountInput;
}>;

export type BuildSignedUrlForAccountMutation = {
  __typename?: 'Mutation';
  buildSignedUrlForAccount: {
    __typename?: 'SignedUrlForUpload';
    fileId: any;
    url: string;
  } | null;
};

export type StartProcessingAfrMutationVariables = Exact<{
  input: StartProcessingPreviousAfrInput;
}>;

export type StartProcessingAfrMutation = {
  __typename?: 'Mutation';
  startProcessingPreviousAfr: {
    __typename?: 'StartProcessingPreviousAfrPayload';
    jobId: any | null;
  } | null;
};

export type UpsertDistrictContactMutationVariables = Exact<{
  input: UpsertDistrictContactInput;
}>;

export type UpsertDistrictContactMutation = {
  __typename?: 'Mutation';
  upsertDistrictContact: {
    __typename?: 'UpsertDistrictContactPayload';
    districtContact: { __typename?: 'DistrictContact'; id: any } | null;
  } | null;
};

export type UpsertFutureJobMutationVariables = Exact<{
  input: UpsertFutureJobInput;
}>;

export type UpsertFutureJobMutation = {
  __typename?: 'Mutation';
  upsertFutureJob: {
    __typename?: 'UpsertFutureJobPayload';
    futureJob: {
      __typename?: 'FutureJob';
      id: any;
      taskData: { [key: string]: any } | null;
    } | null;
  } | null;
};

export type ActiveFiscalYearsQueryVariables = Exact<{ [key: string]: never }>;

export type ActiveFiscalYearsQuery = {
  __typename?: 'Query';
  fiscalYears: {
    __typename?: 'FiscalYearsConnection';
    nodes: Array<{
      __typename?: 'FiscalYear';
      id: any;
      value: number;
      preview: boolean;
      budgetRevisionMode: boolean;
    }>;
  } | null;
};

export type AllAccountFeaturesQueryVariables = Exact<{ [key: string]: never }>;

export type AllAccountFeaturesQuery = {
  __typename?: 'Query';
  accounts: {
    __typename?: 'AccountsConnection';
    nodes: Array<{
      __typename?: 'Account';
      id: any;
      name: string;
      accountFeatures: {
        __typename?: 'AccountFeaturesConnection';
        nodes: Array<{
          __typename?: 'AccountFeature';
          expiresAt: string | null;
          feature: {
            __typename?: 'Feature';
            id: any;
            name: string;
            scopeSelector: string;
          } | null;
        }>;
      };
    }>;
  } | null;
  features: {
    __typename?: 'FeaturesConnection';
    nodes: Array<{
      __typename?: 'Feature';
      id: any;
      name: string;
      scopeSelector: string;
    }>;
  } | null;
};

export type AllEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type AllEntitiesQuery = {
  __typename?: 'Query';
  accounts: {
    __typename?: 'AccountsConnection';
    nodes: Array<{
      __typename?: 'Account';
      id: any;
      name: string;
      state: {
        __typename?: 'State';
        id: any;
        name: string;
        code: string;
      } | null;
    }>;
  } | null;
};

export type BudgetFileDetailsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYear: Scalars['Int'];
  previousFiscalYear: Scalars['Int'];
  previousFiscalYear2: Scalars['Int'];
}>;

export type BudgetFileDetailsQuery = {
  __typename?: 'Query';
  currentFiscalYear: {
    __typename?: 'FiscalYearsConnection';
    nodes: Array<{
      __typename?: 'FiscalYear';
      id: any;
      value: number;
      accountFiscalYears: {
        __typename?: 'AccountFiscalYearsConnection';
        nodes: Array<{
          __typename?: 'AccountFiscalYear';
          externalBudgetDataFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
            extractedData: { [key: string]: any } | null;
          } | null;
        }>;
      };
    }>;
  } | null;
  prevFiscalYear: {
    __typename?: 'FiscalYearsConnection';
    nodes: Array<{
      __typename?: 'FiscalYear';
      id: any;
      value: number;
      accountFiscalYears: {
        __typename?: 'AccountFiscalYearsConnection';
        nodes: Array<{
          __typename?: 'AccountFiscalYear';
          budgetFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
            extractedData: { [key: string]: any } | null;
          } | null;
          desegBudgetFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
            extractedData: { [key: string]: any } | null;
          } | null;
        }>;
      };
    }>;
  } | null;
  prevFiscalYears2: {
    __typename?: 'FiscalYearsConnection';
    nodes: Array<{
      __typename?: 'FiscalYear';
      id: any;
      value: number;
      accountFiscalYears: {
        __typename?: 'AccountFiscalYearsConnection';
        nodes: Array<{
          __typename?: 'AccountFiscalYear';
          budgetFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
            extractedData: { [key: string]: any } | null;
          } | null;
        }>;
      };
    }>;
  } | null;
};

export type BudgetReportQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type BudgetReportQuery = {
  __typename?: 'Query';
  reports: {
    __typename?: 'ReportsConnection';
    edges: Array<{
      __typename?: 'ReportsEdge';
      node: {
        __typename?: 'Report';
        id: any;
        completedAt: string | null;
        errorDetails: string | null;
        name: string;
        status: ReportStatus;
      };
    }>;
  } | null;
};

export type BudgetRevisionDetailsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  prevFiscalYearId: Scalars['UUID'];
}>;

export type BudgetRevisionDetailsQuery = {
  __typename?: 'Query';
  current: {
    __typename?: 'AccountFiscalYear';
    adoptedBudgetFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
      extractedData: { [key: string]: any } | null;
    } | null;
    externalBudgetRevisionDataFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
      extractedData: { [key: string]: any } | null;
    } | null;
    budgetRevisionExtractedDataFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
      extractedData: { [key: string]: any } | null;
    } | null;
  } | null;
  previous: {
    __typename?: 'AccountFiscalYear';
    finalAfrFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
      extractedData: { [key: string]: any } | null;
    } | null;
  } | null;
};

export type BudgetRevisionPrereqFilesQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  prevFiscalYearId: Scalars['UUID'];
}>;

export type BudgetRevisionPrereqFilesQuery = {
  __typename?: 'Query';
  current: {
    __typename?: 'AccountFiscalYear';
    adoptedBudgetFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
  } | null;
  previous: {
    __typename?: 'AccountFiscalYear';
    budgetFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
    finalAfrFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
  } | null;
};

export type BudgetRevisionReportDataQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
  prevFiscalYearId: Scalars['UUID'];
}>;

export type BudgetRevisionReportDataQuery = {
  __typename?: 'Query';
  current: {
    __typename?: 'AccountFiscalYear';
    bsa55PaymentPeriod: string | null;
    adoptedBudgetFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
    bsa55File: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
    budg75File: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
  } | null;
  previous: {
    __typename?: 'AccountFiscalYear';
    budgetFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
    finalAfrFile: {
      __typename?: 'File';
      id: any;
      extension: string | null;
      name: string | null;
    } | null;
  } | null;
  reports: {
    __typename?: 'ReportsConnection';
    nodes: Array<{
      __typename?: 'Report';
      id: any;
      completedAt: string | null;
      createdAt: string;
      errorDetails: string | null;
      name: string;
      status: ReportStatus;
      reportFile: {
        __typename?: 'File';
        id: any;
        extension: string | null;
        name: string | null;
        uploaded: boolean;
        url: string | null;
        size: any;
      } | null;
    }>;
  } | null;
};

export type BudgetRevisionReportsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type BudgetRevisionReportsQuery = {
  __typename?: 'Query';
  reports: {
    __typename?: 'ReportsConnection';
    edges: Array<{
      __typename?: 'ReportsEdge';
      node: {
        __typename?: 'Report';
        id: any;
        completedAt: string | null;
        errorDetails: string | null;
        name: string;
        status: ReportStatus;
      };
    }>;
  } | null;
};

export type ChartOfAccountsFileQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type ChartOfAccountsFileQuery = {
  __typename?: 'Query';
  fiscalYears: {
    __typename?: 'FiscalYearsConnection';
    nodes: Array<{
      __typename?: 'FiscalYear';
      id: any;
      accountFiscalYears: {
        __typename?: 'AccountFiscalYearsConnection';
        nodes: Array<{
          __typename?: 'AccountFiscalYear';
          chartOfAccountsFile: {
            __typename?: 'File';
            id: any;
            name: string | null;
            extension: string | null;
            status: string | null;
            errorMessage: string | null;
          } | null;
        }>;
      };
    }>;
  } | null;
};

export type CurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserQuery = {
  __typename?: 'Query';
  currentUser: {
    __typename?: 'User';
    id: any;
    name: string | null;
    isServiceUser: boolean;
    isSystemAdmin: boolean;
    hasAcceptedTerms: boolean | null;
    hasGivenMarketingConsent: boolean | null;
    avatarUrl: string | null;
    username: string | null;
    userEmails: {
      __typename?: 'UserEmailsConnection';
      nodes: Array<{ __typename?: 'UserEmail'; id: any; email: string }>;
    };
    accountMemberships: {
      __typename?: 'AccountMembershipsConnection';
      nodes: Array<{
        __typename?: 'AccountMembership';
        id: any;
        account: {
          __typename?: 'Account';
          name: string;
          id: any;
          state: {
            __typename?: 'State';
            id: any;
            name: string;
            code: string;
          } | null;
        } | null;
        role: { __typename?: 'Role'; name: string; id: any } | null;
      }>;
    };
    inviteLinks: {
      __typename?: 'InviteLinksConnection';
      nodes: Array<{
        __typename?: 'InviteLink';
        id: any;
        state: InviteState;
        account: { __typename?: 'Account'; id: any; name: string } | null;
        role: { __typename?: 'Role'; id: any; name: string } | null;
      }>;
    };
  } | null;
};

export type CurrentUserScopesForAccountQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;

export type CurrentUserScopesForAccountQuery = {
  __typename?: 'Query';
  getMyScopesForAccount: Array<string | null> | null;
};

export type DistrictCoaSegmentsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type DistrictCoaSegmentsQuery = {
  __typename?: 'Query';
  districtCoaSegments: {
    __typename?: 'DistrictCoaSegmentsConnection';
    nodes: Array<{
      __typename?: 'DistrictCoaSegment';
      id: any;
      segmentName: string;
      digitCount: number;
      sortOrder: number;
      isBaseSegment: boolean;
      createdAt: string;
      districtCodeOptionsBySegmentId: {
        __typename?: 'DistrictCodeOptionsConnection';
        nodes: Array<{
          __typename?: 'DistrictCodeOption';
          id: any;
          codeValue: string;
          description: string | null;
        }>;
      };
    }>;
  } | null;
};

export type AfrFinalLedgersQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type AfrFinalLedgersQuery = {
  __typename?: 'Query';
  generalLedgers: {
    __typename?: 'GeneralLedgersConnection';
    nodes: Array<{
      __typename?: 'GeneralLedger';
      id: any;
      errorDetails: string | null;
      displayName: string;
      status: GeneralLedgerStatus;
      uploadedDate: string;
      reports: {
        __typename?: 'ReportsConnection';
        nodes: Array<{
          __typename?: 'Report';
          id: any;
          createdAt: string;
          completedAt: string | null;
          jobId: any | null;
          name: string;
          status: ReportStatus;
          type: ReportType;
          fileTemplateVersion: {
            __typename?: 'FileTemplateVersion';
            id: any;
            afrVersion: string;
            afrDate: string;
            memo: string;
            slVersion: string;
            systemVersion: number;
          } | null;
          reportFile: {
            __typename?: 'File';
            extension: string | null;
            uploaded: boolean;
            url: string | null;
            size: any;
            name: string | null;
            id: any;
          } | null;
        }>;
      };
      fiscalYear: { __typename?: 'FiscalYear'; id: any; value: number } | null;
    }>;
  } | null;
};

export type EntityClassroomSpendingReportQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type EntityClassroomSpendingReportQuery = {
  __typename?: 'Query';
  generalLedgers: {
    __typename?: 'GeneralLedgersConnection';
    nodes: Array<{
      __typename?: 'GeneralLedger';
      id: any;
      csrChartData: { [key: string]: any } | null;
      jobId: any | null;
      reports: {
        __typename?: 'ReportsConnection';
        nodes: Array<{
          __typename?: 'Report';
          completedAt: string | null;
          id: any;
          generalLedgerId: any | null;
          jobId: any | null;
          status: ReportStatus;
          type: ReportType;
        }>;
      };
    }>;
  } | null;
};

export type EntityCompStudyQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type EntityCompStudyQuery = {
  __typename?: 'Query';
  account: {
    __typename?: 'Account';
    id: any;
    powerBiReportUrl: string | null;
  } | null;
};

export type CtedFinalLedgersQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type CtedFinalLedgersQuery = {
  __typename?: 'Query';
  generalLedgers: {
    __typename?: 'GeneralLedgersConnection';
    nodes: Array<{
      __typename?: 'GeneralLedger';
      id: any;
      displayName: string;
      generateCtedReport: boolean;
      status: GeneralLedgerStatus;
      uploadedDate: string;
      reports: {
        __typename?: 'ReportsConnection';
        nodes: Array<{
          __typename?: 'Report';
          id: any;
          jobId: any | null;
          name: string;
          status: ReportStatus;
          type: ReportType;
          createdAt: string;
          completedAt: string | null;
          errorDetails: string | null;
          reportFile: {
            __typename?: 'File';
            extension: string | null;
            uploaded: boolean;
            url: string | null;
            size: any;
            name: string | null;
            id: any;
          } | null;
        }>;
      };
      fiscalYear: { __typename?: 'FiscalYear'; id: any; value: number } | null;
    }>;
  } | null;
};

export type EntityDetailsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type EntityDetailsQuery = {
  __typename?: 'Query';
  account: {
    __typename?: 'Account';
    id: any;
    name: string;
    afrId: string | null;
    accountFeatures: {
      __typename?: 'AccountFeaturesConnection';
      nodes: Array<{
        __typename?: 'AccountFeature';
        feature: { __typename?: 'Feature'; id: any; name: string } | null;
      }>;
    };
    state: { __typename?: 'State'; id: any; name: string; code: string } | null;
  } | null;
  accountFiscalYear: {
    __typename?: 'AccountFiscalYear';
    afrWebsite: string | null;
    county: string;
    ctdsCode: string;
    hasDesegregation: boolean | null;
    hasFoodService: boolean | null;
    iifValue: string | null;
    schoolLevelAllocation: boolean | null;
    singleSchoolDistrict: boolean | null;
    primaryUnitCode: string;
    threeOrLessYearsTeacherCount: number;
    totalTeacherCount: number;
  } | null;
  districtContacts: {
    __typename?: 'DistrictContactsConnection';
    nodes: Array<{
      __typename?: 'DistrictContact';
      id: any;
      email: string | null;
      firstName: string;
      lastName: string;
      prefix: string | null;
      phone: string | null;
      extension: string | null;
      title: string;
      createdAt: string;
    }>;
  } | null;
  schools: { __typename?: 'SchoolsConnection'; totalCount: number } | null;
};

export type EntityFilesQueryVariables = Exact<{
  id: Scalars['UUID'];
  fiscalYearId?: InputMaybe<Scalars['UUID']>;
}>;

export type EntityFilesQuery = {
  __typename?: 'Query';
  fiscalYears: {
    __typename?: 'FiscalYearsConnection';
    nodes: Array<{
      __typename?: 'FiscalYear';
      id: any;
      value: number;
      accountFiscalYears: {
        __typename?: 'AccountFiscalYearsConnection';
        nodes: Array<{
          __typename?: 'AccountFiscalYear';
          adoptedBudgetFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          budgetFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          finalAfrFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          prevYearAfrFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          prevYearDesegAfrFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          desegBudgetFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          prevYearFoodServiceAfrFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          externalBudgetDataFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          externalBudgetRevisionDataFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          bsa21File: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          chartOfAccountsFile: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          sped20File: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
          sped30File: {
            __typename?: 'File';
            id: any;
            extension: string | null;
            name: string | null;
          } | null;
        }>;
      };
    }>;
  } | null;
};

export type EntityGeneralLedgersQueryVariables = Exact<{
  accountId: Scalars['UUID'];
}>;

export type EntityGeneralLedgersQuery = {
  __typename?: 'Query';
  fiscalYears: {
    __typename?: 'FiscalYearsConnection';
    nodes: Array<{ __typename?: 'FiscalYear'; id: any; value: number }>;
  } | null;
  generalLedgers: {
    __typename?: 'GeneralLedgersConnection';
    nodes: Array<{
      __typename?: 'GeneralLedger';
      id: any;
      accountId: any;
      displayName: string;
      errorDetails: string | null;
      jobId: any | null;
      processingStatus: GeneralLedgerProcessingStatus | null;
      processingStep: GeneralLedgerProcessingStep | null;
      status: GeneralLedgerStatus;
      uploadedDate: string;
      fiscalYear: { __typename?: 'FiscalYear'; id: any; value: number } | null;
      user: {
        __typename?: 'User';
        id: any;
        username: string | null;
        name: string | null;
      } | null;
    }>;
  } | null;
};

export type IdcFinalLedgersQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type IdcFinalLedgersQuery = {
  __typename?: 'Query';
  generalLedgers: {
    __typename?: 'GeneralLedgersConnection';
    nodes: Array<{
      __typename?: 'GeneralLedger';
      id: any;
      displayName: string;
      generateIdcReport: boolean;
      status: GeneralLedgerStatus;
      uploadedDate: string;
      reports: {
        __typename?: 'ReportsConnection';
        nodes: Array<{
          __typename?: 'Report';
          id: any;
          jobId: any | null;
          name: string;
          status: ReportStatus;
          type: ReportType;
          completedAt: string | null;
          reportFile: {
            __typename?: 'File';
            extension: string | null;
            uploaded: boolean;
            url: string | null;
            size: any;
            name: string | null;
            id: any;
          } | null;
        }>;
      };
      fiscalYear: { __typename?: 'FiscalYear'; id: any; value: number } | null;
    }>;
  } | null;
};

export type EntityPreviousCodeChecksQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type EntityPreviousCodeChecksQuery = {
  __typename?: 'Query';
  generalLedgers: {
    __typename?: 'GeneralLedgersConnection';
    nodes: Array<{
      __typename?: 'GeneralLedger';
      id: any;
      uploadedDate: string;
      codeCheckResults: {
        __typename?: 'CodeCheckResultsConnection';
        totalCount: number;
      };
    }>;
  } | null;
};

export type EntityRecentLedgersQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type EntityRecentLedgersQuery = {
  __typename?: 'Query';
  recentGeneralLedgers: {
    __typename?: 'RecentGeneralLedgersConnection';
    nodes: Array<{
      __typename?: 'RecentGeneralLedgersRecord';
      fiscalYear: number | null;
      finalLedger: {
        __typename?: 'GeneralLedger';
        id: any;
        csrChartData: { [key: string]: any } | null;
        displayName: string;
        jobId: any | null;
        processingStatus: GeneralLedgerProcessingStatus | null;
        status: GeneralLedgerStatus;
        uploadedDate: string;
        reports: {
          __typename?: 'ReportsConnection';
          nodes: Array<{
            __typename?: 'Report';
            id: any;
            jobId: any | null;
            status: ReportStatus;
          }>;
        };
      } | null;
      draftLedger: {
        __typename?: 'GeneralLedger';
        id: any;
        displayName: string;
        jobId: any | null;
        processingStatus: GeneralLedgerProcessingStatus | null;
        status: GeneralLedgerStatus;
        uploadedDate: string;
      } | null;
    }>;
  } | null;
};

export type EntitySchoolsQueryVariables = Exact<{
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type EntitySchoolsQuery = {
  __typename?: 'Query';
  schools: {
    __typename?: 'SchoolsConnection';
    totalCount: number;
    nodes: Array<{
      __typename?: 'School';
      id: any;
      ctdsCode: string;
      isPrivateSchool: boolean;
      name: string;
      numStudents: number;
      primaryUnitCode: string;
      uasc: number;
      unitCodes: Array<string | null>;
      afrId: string | null;
    }>;
  } | null;
};

export type UsersAndRolesForAccountQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;

export type UsersAndRolesForAccountQuery = {
  __typename?: 'Query';
  roles: {
    __typename?: 'RolesConnection';
    nodes: Array<{ __typename?: 'Role'; id: any; name: string }>;
  } | null;
  accountMembers: {
    __typename?: 'AccountMembersConnection';
    nodes: Array<{
      __typename?: 'AccountMember';
      email: string | null;
      roleId: any | null;
      roleName: string | null;
      userId: any | null;
      membershipId: any | null;
      name: string | null;
      username: string | null;
      state: InviteState | null;
      inviteLinkId: any | null;
    }>;
  } | null;
};

export type FutureJobQueryVariables = Exact<{
  taskName: Scalars['String'];
  accountId: Scalars['UUID'];
  fiscalYearId: Scalars['UUID'];
}>;

export type FutureJobQuery = {
  __typename?: 'Query';
  futureJobs: {
    __typename?: 'FutureJobsConnection';
    nodes: Array<{
      __typename?: 'FutureJob';
      id: any;
      taskData: { [key: string]: any } | null;
      taskName: string;
    }>;
  } | null;
};

export type GeneralLedgerCsrDataQueryVariables = Exact<{
  ledgerId: Scalars['UUID'];
}>;

export type GeneralLedgerCsrDataQuery = {
  __typename?: 'Query';
  generalLedger: {
    __typename?: 'GeneralLedger';
    id: any;
    csrChartData: { [key: string]: any } | null;
    fiscalYear: { __typename?: 'FiscalYear'; id: any; value: number } | null;
    reports: {
      __typename?: 'ReportsConnection';
      nodes: Array<{
        __typename?: 'Report';
        id: any;
        jobId: any | null;
        status: ReportStatus;
      }>;
    };
  } | null;
};

export type GeneralLedgerCodeCheckDocumentQueryVariables = Exact<{
  ledgerId: Scalars['UUID'];
}>;

export type GeneralLedgerCodeCheckDocumentQuery = {
  __typename?: 'Query';
  generalLedger: {
    __typename?: 'GeneralLedger';
    id: any;
    displayName: string;
    errorDetails: string | null;
    processingStatus: GeneralLedgerProcessingStatus | null;
    processingStep: GeneralLedgerProcessingStep | null;
    status: GeneralLedgerStatus;
    uploadedDate: string;
    reports: {
      __typename?: 'ReportsConnection';
      nodes: Array<{ __typename?: 'Report'; id: any }>;
    };
    codeCheckResults: {
      __typename?: 'CodeCheckResultsConnection';
      totalCount: number;
      nodes: Array<{
        __typename?: 'CodeCheckResult';
        amount: any;
        classification: string | null;
        description: string;
        details: string;
        originalAccountCode: string;
        severity: CodeCheckResultSeverity;
        sourceLine: number;
      }>;
    };
    fiscalYear: { __typename?: 'FiscalYear'; id: any; value: number } | null;
    user: {
      __typename?: 'User';
      id: any;
      name: string | null;
      username: string | null;
    } | null;
  } | null;
};

export type GeneralLedgerProgressQueryVariables = Exact<{
  ledgerId: Scalars['UUID'];
}>;

export type GeneralLedgerProgressQuery = {
  __typename?: 'Query';
  generalLedger: {
    __typename?: 'GeneralLedger';
    id: any;
    errorDetails: string | null;
    processingStatus: GeneralLedgerProcessingStatus | null;
    processingStep: GeneralLedgerProcessingStep | null;
    progressPercent: number | null;
  } | null;
};

export type GeneralLedgerReportProgressQueryVariables = Exact<{
  ledgerId: Scalars['UUID'];
}>;

export type GeneralLedgerReportProgressQuery = {
  __typename?: 'Query';
  generalLedger: {
    __typename?: 'GeneralLedger';
    id: any;
    csrChartData: { [key: string]: any } | null;
    reports: {
      __typename?: 'ReportsConnection';
      nodes: Array<{
        __typename?: 'Report';
        id: any;
        errorDetails: string | null;
        generalLedgerId: any | null;
        status: ReportStatus;
        type: ReportType;
      }>;
    };
  } | null;
};

export type JobResultQueryVariables = Exact<{
  jobId: Scalars['UUID'];
}>;

export type JobResultQuery = {
  __typename?: 'Query';
  jobResult: {
    __typename?: 'JobResult';
    id: any;
    result: { [key: string]: any } | null;
    status: string;
    updatedAt: string;
  } | null;
};

export type LatestTemplateVersionQueryVariables = Exact<{
  fiscalYearId: Scalars['UUID'];
}>;

export type LatestTemplateVersionQuery = {
  __typename?: 'Query';
  fileTemplateVersions: {
    __typename?: 'FileTemplateVersionsConnection';
    edges: Array<{
      __typename?: 'FileTemplateVersionsEdge';
      node: {
        __typename?: 'FileTemplateVersion';
        id: any;
        afrVersion: string;
        slVersion: string;
        systemVersion: number;
      };
    }>;
  } | null;
};

export type NotificationsQueryVariables = Exact<{
  acknowledged: Scalars['Boolean'];
}>;

export type NotificationsQuery = {
  __typename?: 'Query';
  notificationsOwners: {
    __typename?: 'NotificationsOwnersConnection';
    nodes: Array<{
      __typename?: 'NotificationsOwner';
      acknowledged: boolean;
      notifications: {
        __typename?: 'Notification';
        id: any;
        message: string;
      } | null;
    }>;
  } | null;
};

export type PendingInviteLinksQueryVariables = Exact<{
  userId: Scalars['UUID'];
}>;

export type PendingInviteLinksQuery = {
  __typename?: 'Query';
  inviteLinks: {
    __typename?: 'InviteLinksConnection';
    nodes: Array<{
      __typename?: 'InviteLink';
      id: any;
      state: InviteState;
      account: { __typename?: 'Account'; id: any; name: string } | null;
    }>;
  } | null;
};

export const AcceptInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcceptInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inviteLinkId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientMutationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'inviteLinkId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'inviteLinkId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientMutationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clientMutationId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inviteLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AcceptInviteMutation,
  AcceptInviteMutationVariables
>;
export const AcceptTermsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcceptTerms' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientMutationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptTerms' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientMutationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clientMutationId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptTermsMutation, AcceptTermsMutationVariables>;
export const AcknowledgeNotificationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AcknowledgeNotification' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AcknowledgeNotificationInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acknowledgeNotification' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AcknowledgeNotificationMutation,
  AcknowledgeNotificationMutationVariables
>;
export const DownloadFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DownloadFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fileId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildFileDownloadUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fileId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'extension' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadFileMutation,
  DownloadFileMutationVariables
>;
export const CreateGeneralLedgerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateGeneralLedger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateGeneralLedgerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGeneralLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'generalLedger' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateGeneralLedgerMutation,
  CreateGeneralLedgerMutationVariables
>;
export const BuildSignedUrlForLedgerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuildSignedUrlForLedger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BuildSignedUrlForLedgerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildSignedUrlForLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuildSignedUrlForLedgerMutation,
  BuildSignedUrlForLedgerMutationVariables
>;
export const MarkFileUploadedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'MarkFileUploaded' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'MarkFileUploadedInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markFileUploaded' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MarkFileUploadedMutation,
  MarkFileUploadedMutationVariables
>;
export const StartProcessingLedgerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartProcessingLedger' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StartProcessingLedgerInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startProcessingLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartProcessingLedgerMutation,
  StartProcessingLedgerMutationVariables
>;
export const GenerateBudgetRevisionReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateBudgetRevisionReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientMutationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateBudgetRevisionReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientMutationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clientMutationId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateBudgetRevisionReportMutation,
  GenerateBudgetRevisionReportMutationVariables
>;
export const GenerateCsrReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateCSRReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientMutationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateCsrReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientMutationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clientMutationId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ledgerId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'ledgerId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateCsrReportMutation,
  GenerateCsrReportMutationVariables
>;
export const GenerateCtedReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateCTEDReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientMutationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateCtedReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientMutationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clientMutationId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ledgerId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'ledgerId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateCtedReportMutation,
  GenerateCtedReportMutationVariables
>;
export const GenerateIndirectCostReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'GenerateIndirectCostReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientMutationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generateIndirectCostReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientMutationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clientMutationId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ledgerId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'ledgerId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateIndirectCostReportMutation,
  GenerateIndirectCostReportMutationVariables
>;
export const StartGeneratingReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartGeneratingReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startGeneratingReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'ledgerId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'ledgerId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartGeneratingReportMutation,
  StartGeneratingReportMutationVariables
>;
export const LedgerWithReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LedgerWithReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ledgerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reports' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'orderBy' },
                      value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
                    },
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'first' },
                      value: { kind: 'IntValue', value: '1' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errorDetails' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jobId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reportFile' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'extension' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'size' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'uploaded' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LedgerWithReportQuery,
  LedgerWithReportQueryVariables
>;
export const GenerateReportJobResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GenerateReportJobResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobResult' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'jobId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GenerateReportJobResultQuery,
  GenerateReportJobResultQueryVariables
>;
export const DownloadReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DownloadReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'reportId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildReportDownloadUrl' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'reportId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DownloadReportMutation,
  DownloadReportMutationVariables
>;
export const InviteUserToAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InviteUserToAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'roleId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inviteToAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'roleId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'roleId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InviteUserToAccountMutation,
  InviteUserToAccountMutationVariables
>;
export const KickMemberDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'KickMember' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'membershipId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'kickMember' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'membershipId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'membershipId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KickMemberMutation, KickMemberMutationVariables>;
export const LeaveEntityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'LeaveEntity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leaveAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeaveEntityMutation, LeaveEntityMutationVariables>;
export const LogoutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'Logout' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'logout' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoutUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const RejectInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RejectInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inviteLinkId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'clientMutationId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'inviteLinkId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'inviteLinkId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientMutationId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'clientMutationId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inviteLink' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RejectInviteMutation,
  RejectInviteMutationVariables
>;
export const RevokeInviteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RevokeInvite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'inviteLinkId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revokeInvite' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'inviteLinkId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'inviteLinkId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RevokeInviteMutation,
  RevokeInviteMutationVariables
>;
export const UpsertSchoolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertSchool' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpsertSchoolInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertSchool' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'school' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertSchoolMutation,
  UpsertSchoolMutationVariables
>;
export const DeleteSchoolDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteSchool' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'schoolId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteSchool' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'schoolId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'schoolId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteSchoolMutation,
  DeleteSchoolMutationVariables
>;
export const SingleCodeCheckDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SingleCodeCheck' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYear' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'singleCodeCheck' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountCode' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountCode' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYear' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYear' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'classification' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'details' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'originalAccountCode' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'severity' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SingleCodeCheckMutation,
  SingleCodeCheckMutationVariables
>;
export const StartFutureJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartFutureJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StartFutureJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startFutureJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'newJobKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartFutureJobMutation,
  StartFutureJobMutationVariables
>;
export const StartScrapeRunDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartScrapeRun' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startScrapeRun' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attemptId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'runToken' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartScrapeRunMutation,
  StartScrapeRunMutationVariables
>;
export const SubmitHelpTicketDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SubmitHelpTicket' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SubmitHelpTicketInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitHelpTicket' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'helpTicket' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitHelpTicketMutation,
  SubmitHelpTicketMutationVariables
>;
export const UpdateAccountFeatureExpirationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAccountFeatureExpiration' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'featureId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newExpiresAt' },
          },
          type: {
            kind: 'NamedType',
            name: { kind: 'Name', value: 'Datetime' },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountFeatureExpiration' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pAccountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pFeatureId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'featureId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'pNewExpiresAt' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newExpiresAt' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountFeature' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'featureId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'expiresAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAccountFeatureExpirationMutation,
  UpdateAccountFeatureExpirationMutationVariables
>;
export const UpdateAfrWebsiteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAfrWebsite' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newAfrWebsite' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newAfrWebsite' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newAfrWebsite' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'afrWebsite' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAfrWebsiteMutation,
  UpdateAfrWebsiteMutationVariables
>;
export const UpdateCountyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCounty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newCounty' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newCounty' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newCounty' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'county' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCountyMutation,
  UpdateCountyMutationVariables
>;
export const UpdateCtdsCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateCtdsCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newCtdsCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newCtdsCode' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newCtdsCode' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctdsCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCtdsCodeMutation,
  UpdateCtdsCodeMutationVariables
>;
export const UpdateDesegDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateDeseg' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newHasDesegregation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newHasDesegregation' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newHasDesegregation' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasDesegregation' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDesegMutation, UpdateDesegMutationVariables>;
export const UpdateEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'emailId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeUserEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newEmail' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'email' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'emailUuid' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'emailId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdateFoodServiceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFoodService' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newHasFoodService' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newHasFoodService' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newHasFoodService' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'hasFoodService' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFoodServiceMutation,
  UpdateFoodServiceMutationVariables
>;
export const UpdateFullNameDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateFullName' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newName' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateFullNameMutation,
  UpdateFullNameMutationVariables
>;
export const UpdateIifValueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateIIFValue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newIIFValue' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newIifValue' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newIIFValue' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'iifValue' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateIifValueMutation,
  UpdateIifValueMutationVariables
>;
export const UpdateMarketingConsentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateMarketingConsent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newMarketingConsent' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newMarketingConsent' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newMarketingConsent' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMarketingConsentMutation,
  UpdateMarketingConsentMutationVariables
>;
export const UpdatePrimaryUnitCodeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePrimaryUnitCode' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newPrimaryUnitCode' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newPrimaryUnitCode' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newPrimaryUnitCode' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryUnitCode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePrimaryUnitCodeMutation,
  UpdatePrimaryUnitCodeMutationVariables
>;
export const UpdateSchoolLevelAllocationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSchoolLevelAllocation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newSchoolLevelAllocation' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newSchoolLevelAllocation' },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'newSchoolLevelAllocation',
                        },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'schoolLevelAllocation' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSchoolLevelAllocationMutation,
  UpdateSchoolLevelAllocationMutationVariables
>;
export const UpdateSingleSchoolDistrictDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSingleSchoolDistrict' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newSingleSchoolDistrict' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newSingleSchoolDistrict' },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'newSingleSchoolDistrict',
                        },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'singleSchoolDistrict' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateSingleSchoolDistrictMutation,
  UpdateSingleSchoolDistrictMutationVariables
>;
export const UpdateThreeOrLessYearsTeacherCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateThreeOrLessYearsTeacherCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newThreeOrLessYearsTeacherCount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: {
                        kind: 'Name',
                        value: 'newThreeOrLessYearsTeacherCount',
                      },
                      value: {
                        kind: 'Variable',
                        name: {
                          kind: 'Name',
                          value: 'newThreeOrLessYearsTeacherCount',
                        },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'threeOrLessYearsTeacherCount',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateThreeOrLessYearsTeacherCountMutation,
  UpdateThreeOrLessYearsTeacherCountMutationVariables
>;
export const UpdateTotalTeacherCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateTotalTeacherCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'newTotalTeacherCount' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccountSettings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'newTotalTeacherCount' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'newTotalTeacherCount' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalTeacherCount' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateTotalTeacherCountMutation,
  UpdateTotalTeacherCountMutationVariables
>;
export const UpdateUserMembershipDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUserMembership' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'membershipId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'toRole' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeMemberRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'membershipId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'membershipId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'roleId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'toRole' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientMutationId' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateUserMembershipMutation,
  UpdateUserMembershipMutationVariables
>;
export const BuildSignedUrlForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BuildSignedUrlForAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'BuildSignedUrlForAccountInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'buildSignedUrlForAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fileId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BuildSignedUrlForAccountMutation,
  BuildSignedUrlForAccountMutationVariables
>;
export const StartProcessingAfrDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartProcessingAFR' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StartProcessingPreviousAfrInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startProcessingPreviousAfr' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartProcessingAfrMutation,
  StartProcessingAfrMutationVariables
>;
export const UpsertDistrictContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertDistrictContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpsertDistrictContactInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertDistrictContact' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'districtContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertDistrictContactMutation,
  UpsertDistrictContactMutationVariables
>;
export const UpsertFutureJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertFutureJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpsertFutureJobInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertFutureJob' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'futureJob' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taskData' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertFutureJobMutation,
  UpsertFutureJobMutationVariables
>;
export const ActiveFiscalYearsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ActiveFiscalYears' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fiscalYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'VALUE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preview' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'budgetRevisionMode' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ActiveFiscalYearsQuery,
  ActiveFiscalYearsQueryVariables
>;
export const AllAccountFeaturesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllAccountFeatures' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountFeatures' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'feature' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'scopeSelector',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'expiresAt' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'scopeSelector' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllAccountFeaturesQuery,
  AllAccountFeaturesQueryVariables
>;
export const AllEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accounts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'state' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'code' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllEntitiesQuery, AllEntitiesQueryVariables>;
export const BudgetFileDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BudgetFileDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYear' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'previousFiscalYear' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'previousFiscalYear2' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'currentFiscalYear' },
            name: { kind: 'Name', value: 'fiscalYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'value' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYear' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountFiscalYears' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'accountId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'accountId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'externalBudgetDataFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extractedData',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'prevFiscalYear' },
            name: { kind: 'Name', value: 'fiscalYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'value' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'previousFiscalYear' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountFiscalYears' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'accountId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'accountId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'budgetFile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extractedData',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'desegBudgetFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extractedData',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'prevFiscalYears2' },
            name: { kind: 'Name', value: 'fiscalYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'value' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'previousFiscalYear2' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountFiscalYears' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'accountId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'accountId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'budgetFile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extractedData',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BudgetFileDetailsQuery,
  BudgetFileDetailsQueryVariables
>;
export const BudgetReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BudgetReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'BUDGET' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '10' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errorDetails' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BudgetReportQuery, BudgetReportQueryVariables>;
export const BudgetRevisionDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BudgetRevisionDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'prevFiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'current' },
            name: {
              kind: 'Name',
              value: 'accountFiscalYearByAccountIdAndFiscalYearId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adoptedBudgetFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extractedData' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'externalBudgetRevisionDataFile',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extractedData' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: {
                    kind: 'Name',
                    value: 'budgetRevisionExtractedDataFile',
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extractedData' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'previous' },
            name: {
              kind: 'Name',
              value: 'accountFiscalYearByAccountIdAndFiscalYearId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'prevFiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalAfrFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extractedData' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BudgetRevisionDetailsQuery,
  BudgetRevisionDetailsQueryVariables
>;
export const BudgetRevisionPrereqFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BudgetRevisionPrereqFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'prevFiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'current' },
            name: {
              kind: 'Name',
              value: 'accountFiscalYearByAccountIdAndFiscalYearId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adoptedBudgetFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'previous' },
            name: {
              kind: 'Name',
              value: 'accountFiscalYearByAccountIdAndFiscalYearId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'prevFiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'budgetFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalAfrFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BudgetRevisionPrereqFilesQuery,
  BudgetRevisionPrereqFilesQueryVariables
>;
export const BudgetRevisionReportDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BudgetRevisionReportData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'prevFiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'current' },
            name: {
              kind: 'Name',
              value: 'accountFiscalYearByAccountIdAndFiscalYearId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adoptedBudgetFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bsa55File' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'budg75File' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'bsa55PaymentPeriod' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'previous' },
            name: {
              kind: 'Name',
              value: 'accountFiscalYearByAccountIdAndFiscalYearId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'prevFiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'budgetFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'finalAfrFile' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'BUDGET_REVISION' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '10' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorDetails' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reportFile' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'extension' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uploaded' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'size' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BudgetRevisionReportDataQuery,
  BudgetRevisionReportDataQueryVariables
>;
export const BudgetRevisionReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BudgetRevisionReports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: { kind: 'EnumValue', value: 'BUDGET_REVISION' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '10' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedAt' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errorDetails' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BudgetRevisionReportsQuery,
  BudgetRevisionReportsQueryVariables
>;
export const ChartOfAccountsFileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ChartOfAccountsFile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fiscalYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountFiscalYears' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'accountId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'accountId' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'chartOfAccountsFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'status',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'errorMessage',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChartOfAccountsFileQuery,
  ChartOfAccountsFileQueryVariables
>;
export const CurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currentUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isServiceUser' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'isSystemAdmin' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasAcceptedTerms' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasGivenMarketingConsent' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'avatarUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userEmails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'email' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountMemberships' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'state' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'code' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inviteLinks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'account' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserScopesForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CurrentUserScopesForAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyScopesForAccount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CurrentUserScopesForAccountQuery,
  CurrentUserScopesForAccountQueryVariables
>;
export const DistrictCoaSegmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DistrictCoaSegments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'districtCoaSegments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'segmentName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'digitCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sortOrder' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isBaseSegment' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'districtCodeOptionsBySegmentId',
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'codeValue' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'description',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DistrictCoaSegmentsQuery,
  DistrictCoaSegmentsQueryVariables
>;
export const AfrFinalLedgersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AfrFinalLedgers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedgers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'source' },
                      value: { kind: 'EnumValue', value: 'CODE_CHECK' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'FINAL' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'UPLOADED_DATE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorDetails' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadedDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reports' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'type' },
                                  value: { kind: 'EnumValue', value: 'AFR' },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'orderBy' },
                            value: {
                              kind: 'EnumValue',
                              value: 'CREATED_AT_DESC',
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'completedAt',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'jobId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'fileTemplateVersion',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'afrVersion',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'afrDate',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'memo' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'slVersion',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'systemVersion',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reportFile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'uploaded',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'url' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'size' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fiscalYear' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AfrFinalLedgersQuery,
  AfrFinalLedgersQueryVariables
>;
export const EntityClassroomSpendingReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityClassroomSpendingReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedgers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'FINAL' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'UPLOADED_DATE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'csrChartData' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reports' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'completedAt',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'generalLedgerId',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'jobId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityClassroomSpendingReportQuery,
  EntityClassroomSpendingReportQueryVariables
>;
export const EntityCompStudyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityCompStudy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'powerBiReportUrl' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityCompStudyQuery,
  EntityCompStudyQueryVariables
>;
export const CtedFinalLedgersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CtedFinalLedgers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedgers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'source' },
                      value: { kind: 'EnumValue', value: 'CODE_CHECK' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'FINAL' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'UPLOADED_DATE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'generateCtedReport' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadedDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reports' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'type' },
                                  value: { kind: 'EnumValue', value: 'CTED' },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'orderBy' },
                            value: {
                              kind: 'EnumValue',
                              value: 'CREATED_AT_DESC',
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'jobId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdAt' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'completedAt',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'errorDetails',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reportFile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'uploaded',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'url' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'size' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fiscalYear' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CtedFinalLedgersQuery,
  CtedFinalLedgersQueryVariables
>;
export const EntityDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'account' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'afrId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountFeatures' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'feature' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'state' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'accountFiscalYear' },
            name: {
              kind: 'Name',
              value: 'accountFiscalYearByAccountIdAndFiscalYearId',
            },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'afrWebsite' } },
                { kind: 'Field', name: { kind: 'Name', value: 'county' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ctdsCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasDesegregation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'hasFoodService' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'iifValue' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schoolLevelAllocation' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'singleSchoolDistrict' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryUnitCode' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'threeOrLessYearsTeacherCount' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'totalTeacherCount' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'districtContacts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'EnumValue', value: 'CREATED_AT_ASC' }],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'prefix' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'extension' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdAt' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schools' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EntityDetailsQuery, EntityDetailsQueryVariables>;
export const EntityFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fiscalYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'VALUE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountFiscalYears' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'accountId' },
                                  value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'adoptedBudgetFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'budgetFile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'finalAfrFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'prevYearAfrFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'prevYearDesegAfrFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'desegBudgetFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'prevYearFoodServiceAfrFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'externalBudgetDataFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'externalBudgetRevisionDataFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'bsa21File' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'chartOfAccountsFile',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sped20File' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sped30File' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EntityFilesQuery, EntityFilesQueryVariables>;
export const EntityGeneralLedgersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityGeneralLedgers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fiscalYears' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'active' },
                      value: { kind: 'BooleanValue', value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedgers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'UPLOADED_DATE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'errorDetails' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processingStatus' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'processingStep' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadedDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fiscalYear' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'username' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityGeneralLedgersQuery,
  EntityGeneralLedgersQueryVariables
>;
export const IdcFinalLedgersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'IdcFinalLedgers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedgers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'source' },
                      value: { kind: 'EnumValue', value: 'CODE_CHECK' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'FINAL' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'UPLOADED_DATE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'displayName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'generateIdcReport' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'status' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadedDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reports' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'condition' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'type' },
                                  value: { kind: 'EnumValue', value: 'IDC' },
                                },
                              ],
                            },
                          },
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'orderBy' },
                            value: {
                              kind: 'EnumValue',
                              value: 'COMPLETED_AT_DESC',
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'nodes' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'jobId' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'type' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'completedAt',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reportFile' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'extension',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'uploaded',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'url' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'size' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'name' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fiscalYear' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'value' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  IdcFinalLedgersQuery,
  IdcFinalLedgersQueryVariables
>;
export const EntityPreviousCodeChecksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityPreviousCodeChecks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedgers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'source' },
                      value: { kind: 'EnumValue', value: 'CODE_CHECK' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '10' },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'EnumValue', value: 'UPLOADED_DATE_DESC' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uploadedDate' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'codeCheckResults' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'totalCount' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityPreviousCodeChecksQuery,
  EntityPreviousCodeChecksQueryVariables
>;
export const EntityRecentLedgersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntityRecentLedgers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recentGeneralLedgers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'accountId' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fiscalYearId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fiscalYearId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fiscalYear' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalLedger' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'csrChartData' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jobId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'processingStatus' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uploadedDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reports' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'nodes' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'jobId',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'status',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'draftLedger' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayName' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jobId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'processingStatus' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uploadedDate' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  EntityRecentLedgersQuery,
  EntityRecentLedgersQueryVariables
>;
export const EntitySchoolsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'EntitySchools' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schools' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'ctdsCode' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isPrivateSchool' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'numStudents' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'primaryUnitCode' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'uasc' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unitCodes' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'afrId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<EntitySchoolsQuery, EntitySchoolsQueryVariables>;
export const UsersAndRolesForAccountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UsersAndRolesForAccount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'roles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accountMembers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accountId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'id' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roleId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'roleName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'membershipId' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'username' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'inviteLinkId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UsersAndRolesForAccountQuery,
  UsersAndRolesForAccountQueryVariables
>;
export const FutureJobDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FutureJob' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'taskName' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'String' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'accountId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'futureJobs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'taskName' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'taskName' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'accountId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'accountId' },
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taskData' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taskName' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FutureJobQuery, FutureJobQueryVariables>;
export const GeneralLedgerCsrDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneralLedgerCSRData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ledgerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'csrChartData' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fiscalYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reports' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'jobId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeneralLedgerCsrDataQuery,
  GeneralLedgerCsrDataQueryVariables
>;
export const GeneralLedgerCodeCheckDocumentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneralLedgerCodeCheckDocument' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ledgerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errorDetails' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'processingStatus' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'processingStep' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'uploadedDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reports' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'condition' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'type' },
                            value: { kind: 'EnumValue', value: 'AFR' },
                          },
                        ],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'codeCheckResults' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'amount' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'classification' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'description' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'details' },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'originalAccountCode',
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'severity' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sourceLine' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'totalCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fiscalYear' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'username' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeneralLedgerCodeCheckDocumentQuery,
  GeneralLedgerCodeCheckDocumentQueryVariables
>;
export const GeneralLedgerProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneralLedgerProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ledgerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errorDetails' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'processingStatus' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'processingStep' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'progressPercent' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeneralLedgerProgressQuery,
  GeneralLedgerProgressQueryVariables
>;
export const GeneralLedgerReportProgressDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GeneralLedgerReportProgress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'ledgerId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generalLedger' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'ledgerId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'csrChartData' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reports' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'orderBy' },
                      value: { kind: 'EnumValue', value: 'CREATED_AT_DESC' },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nodes' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'errorDetails' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'generalLedgerId' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'type' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GeneralLedgerReportProgressQuery,
  GeneralLedgerReportProgressQueryVariables
>;
export const JobResultDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'JobResult' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'jobId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'jobResult' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'jobId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<JobResultQuery, JobResultQueryVariables>;
export const LatestTemplateVersionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestTemplateVersion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fiscalYearId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileTemplateVersions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'fiscalYearId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'fiscalYearId' },
                      },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: {
                  kind: 'ListValue',
                  values: [{ kind: 'EnumValue', value: 'SYSTEM_VERSION_DESC' }],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'IntValue', value: '1' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'afrVersion' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slVersion' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'systemVersion' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LatestTemplateVersionQuery,
  LatestTemplateVersionQueryVariables
>;
export const NotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Notifications' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'acknowledged' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notificationsOwners' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'acknowledged' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'acknowledged' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'acknowledged' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notifications' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'message' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<NotificationsQuery, NotificationsQueryVariables>;
export const PendingInviteLinksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PendingInviteLinks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'userId' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'inviteLinks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'condition' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'state' },
                      value: { kind: 'EnumValue', value: 'PENDING' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'userId' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'userId' },
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'account' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PendingInviteLinksQuery,
  PendingInviteLinksQueryVariables
>;
